// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/menu_backdrop.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --border-radius-borda: rgb(231, 231, 231);
  --border-radius-radius-none: 0px;
  --border-radius-radius-sm: 6px;
  --border-radius-radius-sm-duplicate: 6px;
  --brand-14bis-blue-dark: rgba(24, 40, 87, 1);
  --brand-14bis-blue-light: rgba(0, 113, 186, 1);
  --brand-14bis-blue-medium: rgba(22, 71, 142, 1);
  --brand-14bis-blue-medium-duplicate: rgba(22, 71, 142, 1);
  --brand-14bis-orange-bright: rgba(242, 101, 34, 1);
  --brand-14bis-orange-matte: rgba(228, 129, 58, 1);
  --brand-color: rgba(0, 113, 186, 1);
  --brand-common-white: rgba(255, 255, 255, 1);
  --brand-neutral-050: rgba(251, 252, 254, 1);
  --brand-neutral-100: rgba(240, 244, 248, 1);
  --brand-neutral-100-duplicate: rgba(240, 244, 248, 1);
  --brand-neutral-200: rgba(221, 231, 238, 1);
  --brand-neutral-300: rgba(205, 215, 225, 1);
  --brand-neutral-400: rgba(159, 166, 173, 1);
  --brand-neutral-500: rgba(99, 107, 116, 1);
  --brand-neutral-800: rgba(23, 26, 28, 1);
  --brand-neutral-800-duplicate: rgba(23, 26, 28, 1);
  --brand-primary-050: rgba(237, 245, 253, 1);
  --brand-primary-100: rgba(227, 239, 251, 1);
  --brand-primary-800: rgba(10, 39, 68, 1);
  --brand-primary-800-duplicate: rgba(10, 39, 68, 1);
  --coloractioncontainersecondary: rgba(255, 255, 255, 1);
  --colorborderactive: rgba(51, 51, 51, 1);
  --colorbordercard: rgba(230, 230, 230, 1);
  --spacing-2: 16px;
  --spacing-brand: rgba(0, 113, 186, 1);
  --theme-background-surface: var(--brand-neutral-050);
  --theme-danger-outlined-disabledborder: var(--brand-neutral-200);
  --theme-danger-outlined-disabledcolor: var(--brand-neutral-400);
  --theme-danger-plain-disabledcolor: var(--brand-neutral-400);
  --theme-danger-solid-color: var(--brand-common-white);
  --theme-danger-solid-disabledbg: var(--brand-neutral-100-duplicate);
  --theme-danger-solid-disabledcolor: var(--brand-neutral-400);
  --theme-divider: rgba(99, 107, 116, 0.3);
  --theme-neutral-outlined-activebg: var(--brand-neutral-200);
  --theme-neutral-outlined-disabledborder: var(--brand-neutral-200);
  --theme-neutral-outlined-disabledcolor: var(--brand-neutral-400);
  --theme-neutral-outlined-hoverbg: var(--brand-neutral-100-duplicate);
  --theme-neutral-plain-activebg: var(--brand-neutral-200);
  --theme-neutral-plain-disabledcolor: var(--brand-neutral-400);
  --theme-neutral-plain-hoverbg: var(--brand-neutral-100-duplicate);
  --theme-neutral-solid-bg: var(--brand-neutral-500);
  --theme-neutral-solid-color: var(--brand-common-white);
  --theme-neutral-solid-disabledbg: var(--brand-neutral-100-duplicate);
  --theme-neutral-solid-disabledcolor: var(--brand-neutral-400);
  --theme-primary-outlined-disabledborder: var(--brand-neutral-200);
  --theme-primary-outlined-disabledborder-duplicate: var(--brand-neutral-200);
  --theme-primary-outlined-disabledcolor: var(--brand-neutral-400);
  --theme-primary-outlined-disabledcolor-duplicate: var(--brand-neutral-400);
  --theme-primary-outlined-hoverbg: var(--brand-primary-100);
  --theme-primary-outlined-hoverbg-duplicate: var(--brand-primary-100);
  --theme-primary-plain-disabledcolor: var(--brand-neutral-400);
  --theme-primary-plain-disabledcolor-duplicate: var(--brand-neutral-400);
  --theme-primary-plain-hoverbg: var(--brand-primary-050);
  --theme-primary-plain-hoverbg-duplicate: var(--brand-primary-050);
  --theme-primary-solid-color: var(--brand-common-white);
  --theme-primary-solid-color-duplicate: var(--brand-common-white);
  --theme-primary-solid-disabledbg: var(--brand-neutral-100-duplicate);
  --theme-primary-solid-disabledbg-duplicate: var(--brand-neutral-100-duplicate);
  --theme-primary-solid-disabledcolor: var(--brand-neutral-400);
  --theme-primary-solid-disabledcolor-duplicate: var(--brand-neutral-400);
  --theme-success-outlined-disabledborder: var(--brand-neutral-200);
  --theme-success-outlined-disabledcolor: var(--brand-neutral-400);
  --theme-success-plain-disabledcolor: var(--brand-neutral-400);
  --theme-success-solid-color: var(--brand-common-white);
  --theme-success-solid-disabledbg: var(--brand-neutral-100-duplicate);
  --theme-success-solid-disabledcolor: var(--brand-neutral-400);
  --theme-text-icon: var(--brand-neutral-500);
  --theme-text-primary: var(--brand-neutral-800-duplicate);
  --theme-warning-outlined-disabledborder: var(--brand-neutral-200);
  --theme-warning-outlined-disabledcolor: var(--brand-neutral-400);
  --theme-warning-plain-disabledcolor: var(--brand-neutral-400);
  --theme-warning-solid-color: var(--brand-common-white);
  --theme-warning-solid-disabledbg: var(--brand-neutral-100-duplicate);
  --theme-warning-solid-disabledcolor: var(--brand-neutral-400);
}

[data-theme-mode="light"] {
  --theme-background-surface: var(--brand-neutral-050);
  --theme-danger-outlined-disabledborder: var(--brand-neutral-200);
  --theme-danger-outlined-disabledcolor: var(--brand-neutral-400);
  --theme-danger-plain-disabledcolor: var(--brand-neutral-400);
  --theme-danger-solid-disabledbg: var(--brand-neutral-100-duplicate);
  --theme-danger-solid-disabledcolor: var(--brand-neutral-400);
  --theme-divider: rgba(99, 107, 116, 0.3);
  --theme-neutral-outlined-disabledborder: var(--brand-neutral-200);
  --theme-neutral-outlined-disabledcolor: var(--brand-neutral-400);
  --theme-neutral-outlined-hoverbg: var(--brand-neutral-100-duplicate);
  --theme-neutral-plain-disabledcolor: var(--brand-neutral-400);
  --theme-neutral-plain-hoverbg: var(--brand-neutral-100-duplicate);
  --theme-neutral-solid-disabledbg: var(--brand-neutral-100-duplicate);
  --theme-neutral-solid-disabledcolor: var(--brand-neutral-400);
  --theme-primary-outlined-disabledborder: var(--brand-neutral-200);
  --theme-primary-outlined-disabledborder-duplicate: var(--brand-neutral-200);
  --theme-primary-outlined-disabledcolor: var(--brand-neutral-400);
  --theme-primary-outlined-disabledcolor-duplicate: var(--brand-neutral-400);
  --theme-primary-outlined-hoverbg: var(--brand-primary-100);
  --theme-primary-outlined-hoverbg-duplicate: var(--brand-primary-100);
  --theme-primary-plain-disabledcolor: var(--brand-neutral-400);
  --theme-primary-plain-disabledcolor-duplicate: var(--brand-neutral-400);
  --theme-primary-plain-hoverbg: var(--brand-primary-050);
  --theme-primary-plain-hoverbg-duplicate: var(--brand-primary-050);
  --theme-primary-solid-disabledbg: var(--brand-neutral-100-duplicate);
  --theme-primary-solid-disabledbg-duplicate: var(--brand-neutral-100-duplicate);
  --theme-primary-solid-disabledcolor: var(--brand-neutral-400);
  --theme-primary-solid-disabledcolor-duplicate: var(--brand-neutral-400);
  --theme-success-outlined-disabledborder: var(--brand-neutral-200);
  --theme-success-outlined-disabledcolor: var(--brand-neutral-400);
  --theme-success-plain-disabledcolor: var(--brand-neutral-400);
  --theme-success-solid-disabledbg: var(--brand-neutral-100-duplicate);
  --theme-success-solid-disabledcolor: var(--brand-neutral-400);
  --theme-text-icon: var(--brand-neutral-500);
  --theme-text-primary: var(--brand-neutral-800-duplicate);
  --theme-warning-outlined-disabledborder: var(--brand-neutral-200);
  --theme-warning-outlined-disabledcolor: var(--brand-neutral-400);
  --theme-warning-plain-disabledcolor: var(--brand-neutral-400);
  --theme-warning-solid-disabledbg: var(--brand-neutral-100-duplicate);
  --theme-warning-solid-disabledcolor: var(--brand-neutral-400);
}

[data-theme-mode="dark"] {
  --theme-danger-outlined-disabledborder: var(--brand-neutral-800-duplicate);
  --theme-danger-outlined-disabledcolor: var(--brand-neutral-500);
  --theme-danger-plain-disabledcolor: var(--brand-neutral-500);
  --theme-danger-solid-disabledbg: var(--brand-neutral-800-duplicate);
  --theme-danger-solid-disabledcolor: var(--brand-neutral-500);
  --theme-divider: rgba(99, 107, 116, 0.16);
  --theme-neutral-outlined-disabledborder: var(--brand-neutral-800-duplicate);
  --theme-neutral-outlined-disabledcolor: var(--brand-neutral-500);
  --theme-neutral-outlined-hoverbg: var(--brand-neutral-800-duplicate);
  --theme-neutral-plain-disabledcolor: var(--brand-neutral-500);
  --theme-neutral-plain-hoverbg: var(--brand-neutral-800-duplicate);
  --theme-neutral-solid-disabledbg: var(--brand-neutral-800-duplicate);
  --theme-neutral-solid-disabledcolor: var(--brand-neutral-500);
  --theme-primary-outlined-disabledborder: var(--brand-neutral-800-duplicate);
  --theme-primary-outlined-disabledborder-duplicate: var(--brand-neutral-800-duplicate);
  --theme-primary-outlined-disabledcolor: var(--brand-neutral-500);
  --theme-primary-outlined-disabledcolor-duplicate: var(--brand-neutral-500);
  --theme-primary-outlined-hoverbg: var(--brand-primary-800);
  --theme-primary-outlined-hoverbg-duplicate: var(--brand-primary-800);
  --theme-primary-plain-disabledcolor: var(--brand-neutral-500);
  --theme-primary-plain-disabledcolor-duplicate: var(--brand-neutral-500);
  --theme-primary-plain-hoverbg: var(--brand-primary-800-duplicate);
  --theme-primary-plain-hoverbg-duplicate: var(--brand-primary-800-duplicate);
  --theme-primary-solid-disabledbg: var(--brand-neutral-800-duplicate);
  --theme-primary-solid-disabledbg-duplicate: var(--brand-neutral-800-duplicate);
  --theme-primary-solid-disabledcolor: var(--brand-neutral-500);
  --theme-primary-solid-disabledcolor-duplicate: var(--brand-neutral-500);
  --theme-success-outlined-disabledborder: var(--brand-neutral-800-duplicate);
  --theme-success-outlined-disabledcolor: var(--brand-neutral-500);
  --theme-success-plain-disabledcolor: var(--brand-neutral-500);
  --theme-success-solid-disabledbg: var(--brand-neutral-800-duplicate);
  --theme-success-solid-disabledcolor: var(--brand-neutral-500);
  --theme-text-icon: var(--brand-neutral-400);
  --theme-text-primary: var(--brand-neutral-100-duplicate);
  --theme-warning-outlined-disabledborder: var(--brand-neutral-800-duplicate);
  --theme-warning-outlined-disabledcolor: var(--brand-neutral-500);
  --theme-warning-plain-disabledcolor: var(--brand-neutral-500);
  --theme-warning-solid-disabledbg: var(--brand-neutral-800-duplicate);
  --theme-warning-solid-disabledcolor: var(--brand-neutral-500);
}

.menu-landing {
  background-color: var(--brand-14bis-blue-light);
  height: 100vh;
  width: 100%;
}

.menu-landing .overlap-group {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 50% 50%;
  background-size: cover;
  background-repeat: no-repeat;
  height: 100%;
  position: relative;
}

.menu-landing .element-logo {
  height: 61px;
  position: relative;
  width: 150px;
}

.menu-landing .frame {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 16px;
  justify-content: flex-end;
  position: relative;
}

.menu-landing .button-instance {
  flex: 0 0 auto !important;
}

.menu-landing .home-button {
  color: var(--brand-14bis-blue-medium);
  flex: 0 0 auto !important;
}

.menu-landing .line-desktop-instance {
  align-self: stretch !important;
  flex: 0 0 auto !important;
  width: 100% !important;
}

.menu-landing .design-component-instance-node {
  background-color: var(--colorbordercard) !important;
}

.menu-landing .start {
  align-items: flex-start;
  display: inline-flex;
  flex-direction: column;
  left: 52px;
  position: absolute;
  top: 273px;
}

.menu-landing .trust-security-and {
  color: var(--theme-primary-solid-color);
  font-family: Open Sans variable, Helvetica;
  font-size: 36px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 46.8px;
  margin-top: -1px;
  position: relative;
  width: 298px;
}

.menu-landing .span {
  font-weight: 700;
}

.menu-landing .text-wrapper-2 {
  color: #fff;
  font-family: Open Sans variable, Helvetica;
  font-size: 36px;
  font-weight: 400;
  letter-spacing: 0 px;
  line-height: 46.8px;
}

.menu-landing .div {
  align-items: flex-start;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  position: relative;
}

.menu-landing .button-wrapper {
  all: unset;
  align-items: center;
  background-color: var(--brand-color);
  border-radius: var(--border-radius-radius-sm-duplicate);
  box-sizing: border-box;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: center;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.menu-landing .button-2 {
  all: unset;
  box-sizing: border-box;
  color: #ffffff;
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.menu-landing .div-wrapper {
  all: unset;
  align-items: center;
  border: 1px solid;
  border-color: var(--theme-primary-outlined-disabledborder-duplicate);
  border-radius: 6px;
  box-sizing: border-box;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: center;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.menu-landing .button-3 {
  all: unset;
  box-sizing: border-box;
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.menu-landing button:not([disabled]) .button-3 {
  color: #ffffff !important;
}

.menu-landing button[disabled] .button-3 {
  color: var(--theme-primary-outlined-disabledcolor-duplicate) !important;
}

.upload-file {
  background-color: var(--brand-neutral-100);
  height: 100vh;
  position: relative;
  width: 100%;
}


.upload-file .element-logo {
  height: 61px;
  position: relative;
  width: 150px;
}

.upload-file .frame {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 16px;
  justify-content: flex-end;
  position: relative;
}

.upload-file .button-instance {
  flex: 0 0 auto !important;
}


.upload-file .home-button {
  color: var(--brand-14bis-blue-medium);
  flex: 0 0 auto !important;
}

.upload-file .line-desktop-instance {
  align-self: stretch !important;
  flex: 0 0 auto !important;
  width: 100% !important;
}

.upload-file .design-component-instance-node {
  background-color: var(--colorbordercard) !important;
  width: 100%;
  height: 100%;
}

.upload-file .under-banner {
  align-items: center;  /* centers horizontally */
  display: flex;
  flex-direction: column;
  padding: 4px 12px;
  position: absolute;   /* keep if needed for placement */
  top: 70px;
  left: 3%;
  width: 91.8%;
  height: 88vh;
}

.upload-file .div {
  position: absolute;
  width: 91.8%;
  background-color: var(--theme-background-surface);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 10px 12px;
  padding-bottom: 80px;
  width: 100%; 
  box-sizing: border-box;       
  position: relative; 
  flex: 1 1; 
}

.upload-file .breadcrumb {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex: none;
  gap: 8px;
  justify-content: center;
  padding: 8px 0px;
  position: relative;
  width: 100%;
}

.upload-file .breadcrumb-2 {
  align-items: center;
  background-color: var(--theme-primary-solid-color);
  border-radius: 6px;
  box-shadow: inset 0px 2px 2px #00000040;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 4px;
  justify-content: center;
  padding: 8px;
  position: relative;
}

.upload-file .button-2 {
  align-items: center;
  border: 1px solid;
  border-color: var(--brand-14bis-orange-matte);
  border-radius: 6px 0px 0px 6px;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: center;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.upload-file .button-3 {
  all: unset;
  box-sizing: border-box;
  color: var(--brand-14bis-orange-matte);
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.upload-file .icons-2 {
  color: var(--brand-14bis-orange-matte);
  height: 28px !important;
  position: relative !important;
  width: 28px !important;
}

.upload-file .button-4 {
  align-items: center;
  background-color: var(--theme-primary-solid-disabledbg-duplicate);
  border: 1px solid;
  border-color: #9fa6ad;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: center;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.upload-file .text-wrapper-2 {
  color: var(--theme-primary-solid-disabledcolor-duplicate);
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.upload-file .icons-3 {
  color: var(--brand-neutral-400);
  height: 28px !important;
  position: relative !important;
  width: 28px !important;
}

.upload-file .icons-4 {
  color: var(--brand-neutral-400);
  height: 28px !important;
  position: relative !important;
  width: 28px !important;
}

.upload-file .icons-5 {
  color: var(--brand-neutral-400);
  height: 28px !important;
  position: relative !important;
  width: 28px !important;
}

.upload-file .button-5 {
  align-items: center;
  background-color: var(--theme-primary-solid-disabledbg-duplicate);
  border: 1px solid;
  border-color: #9fa6ad;
  border-radius: 0px var(--border-radius-radius-sm) var(--border-radius-radius-sm) 0px;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: center;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.upload-file .icons-6 {
  color: var(--brand-neutral-400);
  height: 28px !important;
  position: relative !important;
  width: 28px !important;
}

.upload-file .upload-image-default {
  align-items: stretch;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  min-height: 0;
  flex: 1 1;
}

.upload-file .adicionar-novo-job {
  border-radius: 4px;
  display: flex;
  flex: 1 1;
  flex-direction:column;
  flex-grow: 1;
  gap: 24px;
  justify-content: center;
  padding: 16px;
  position: relative;
  min-height: 0;
}
.upload-file .name-form{
  display: flex;
  justify-content:flex-start;
  padding: 0px;
  align-items: flex-start;
  align-self: stretch;

}
.upload-file .left-side {
  display: flex;
  flex-direction: column; /* stack form above paragraph */
  gap: 10px;  
}

.upload-file .directions {
  font-size: 12px;
  font-family: "Open Sans variable", Helvetica;
  margin: 0; 
}

.upload-file .p-bold {
  font-family: "Open Sans-Bold", Helvetica;
}

.upload-file .upload-button{
  align-items: center;
  align-self: stretch;
  flex: 1 1;
  flex-grow: 1;
  justify-content: center;
  position: relative;
  padding: 0px;
  border-radius: 4px;
}

.upload-file .list-scroll{
  margin: 0px; 
  padding: 0px; 
  display: inline;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  gap: 8px;
}
.upload-file .uploadButton-and-files-container{
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  align-items: center;
  flex: 1 1;
  min-height: 0;
  align-self: stretch;
  background: var(--Grey-200, #E8E8E8);

}
.upload-file .card-add-product {
  align-items: center;
  align-self: stretch;
  background-color: #ffffff;
  border: 1px dashed;
  border-color: var(--brand-neutral-300);
  border-radius: 4px;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  flex-grow: 1;
  float: left;
  gap: 8px;
  justify-content: center;
  position: relative;
  }

.upload-file .upload-instructions {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.upload-file .uploaded-files{
  display: flex;
  padding: 16px 8px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background-color: #ffffff;
  border: 1px dashed;
  border-color: var(--brand-neutral-300);
  border-radius: 4px;
  display: flex;
  flex: 1 1;
}

.upload-file .metricswitch {
  left: -9999px;
  display:none;
  visibility:hidden !important;
  all: unset;
  box-sizing: border-box;
  color: var(--brand-neutral-500);
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  clear: left;
  position: absolute;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.upload-file .icons-7 {
  color: var(--brand-14bis-blue-medium);
  position: relative !important;
}
.upload-file .icons-8 {
  padding: 8px;
  color: var(--theme-text-primary);
}

.upload-file .delete-icon {
  margin-left: auto;
  color:var(--brand-14bis-orange-bright);
  cursor: pointer;
  padding: 8px;
}

.upload-file .delete-icon:hover {
  color:#c82333;

}

.upload-file .p {
  color: var(--brand-neutral-800);
  font-family: Open Sans variable, Helvetica;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 15.6px;
  position: relative;
  text-align: center;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.upload-file .button-wrapper {
  all: unset;
  align-items: center;
  border: 1px solid;
  border-color: var(--brand-color);
  border-radius: 6px;
  box-sizing: border-box;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: flex-end;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.upload-file .button-6 {
  all: unset;
  box-sizing: border-box;
  color: var(--brand-color);
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.upload-file .div-wrapper {
  all: unset;
  align-items: center;
  background-color: var(--brand-color);
  border-radius: var(--border-radius-radius-sm-duplicate);
  box-sizing: border-box;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: flex-end;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.upload-file .button-7 {
  all: unset;
  box-sizing: border-box;
  color: #ffffff;
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.checklist {
  background-color: var(--brand-neutral-100);
  height: 100vh;
  position: relative;
  width: 100%;
}


.checklist .element-logo {
  height: 61px;
  position: relative;
  width: 150px;
}

.checklist .frame {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 16px;
  justify-content: flex-end;
  position: relative;
}

.checklist .button-instance {
  flex: 0 0 auto !important;
}

.checklist .line-desktop-instance {
  align-self: stretch !important;
  flex: 0 0 auto !important;
  width: 100% !important;
}

.checklist .design-component-instance-node {
  background-color: var(--colorbordercard) !important;
}

.checklist .under-banner {
  align-items: center;  /* centers horizontally */
  display: flex;
  flex-direction: column;
  padding: 4px 12px;
  position: absolute;   /* keep if needed for placement */
  top: 70px;
  left: 3%;
  width: 91.8%;
  height: 88vh;
}

.checklist .div {
  background-color: var(--theme-background-surface);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 10px 12px;
  padding-bottom: 92px;
  width: 100%; 
  box-sizing: border-box;       
  position: relative; 
  flex: 1 1;          
}

.checklist .breadcrumb {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  gap: 8px;
  justify-content: center;
  padding: 8px 0px;
  position: relative;
  width: 100%;
}

.checklist .breadcrumb-2 {
  align-items: center;
  background-color: var(--theme-primary-solid-color);
  border-radius: 6px;
  box-shadow: inset 0px 2px 2px #00000040;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 4px;
  justify-content: center;
  padding: 8px;
  position: relative;
}

.checklist .button-2 {
  align-items: center;
  background-color: var(--brand-14bis-orange-matte);
  border-radius: 6px 0px 0px 6px;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: center;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.checklist .button-3 {
  all: unset;
  box-sizing: border-box;
  color: #ffffff;
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.checklist .icons-2 {
  color: var(--brand-common-white);
  height: 28px !important;
  position: relative !important;
  width: 28px !important;
}

.checklist .button-4 {
  align-items: center;
  border: 1px solid;
  border-color: var(--brand-14bis-orange-matte);
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: center;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.checklist .text-wrapper-2 {
  color: var(--brand-14bis-orange-matte);
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.checklist .icons-3 {
  color: var(--brand-14bis-orange-matte);
  height: 28px !important;
  position: relative !important;
  width: 28px !important;
}

.checklist .button-5 {
  align-items: center;
  background-color: var(--theme-primary-solid-disabledbg-duplicate);
  border: 1px solid;
  border-color: #9fa6ad;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: center;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.checklist .text-wrapper-3 {
  color: var(--theme-primary-solid-disabledcolor-duplicate);
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.checklist .icons-4 {
  color: var(--brand-neutral-400);
  height: 28px !important;
  position: relative !important;
  width: 28px !important;
}

.checklist .icons-5 {
  color: var(--brand-neutral-400);
  height: 28px !important;
  position: relative !important;
  width: 28px !important;
}

.checklist .button-6 {
  align-items: center;
  background-color: var(--theme-primary-solid-disabledbg-duplicate);
  border: 1px solid;
  border-color: #9fa6ad;
  border-radius: 0px var(--border-radius-radius-sm) var(--border-radius-radius-sm) 0px;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: center;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.checklist .icons-6 {
  color: var(--brand-neutral-400);
  height: 28px !important;
  position: relative !important;
  width: 28px !important;
}

.checklist .frame-2 {
  align-items: flex-end;
  display: inline-flex;
  flex: 0 0 auto;
  justify-content: flex-end;
  padding: 12px 0px;
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
}

.checklist .frame-3 {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  width: 100%;

}

.checklist .loading-overlay{
  align-self: center;
  margin: auto 0;
}

.checklist .name-form {
  padding: 0px 0px 18px 2px;
  display: flex;
  justify-content: space-between; 
  align-items: center;            
  width: 100%;
}

.checklist .left-side {
  display: flex;
  flex-direction: column; /* stack form above paragraph */
  gap: 10px;  
}

.checklist .directions {
  font-size: 12px;
  font-family: "Open Sans variable", Helvetica;
  margin: 0; 
}

.checklist .p-bold {
  font-family: "Open Sans-Bold", Helvetica;
}

.checklist .additional-items{
  display: flex;
  min-height: 48px;
  padding: 6px 24px;
  justify-content: center;
  align-items: center;
  gap: 12px;
  border-radius: var(--radius-sm, 6px);
  border: 1px solid var(--14bis-Medium, #16478E);
}

.checklist .div-wrapper {
  align-items: center;
  align-self: stretch;
  background-color: var(--theme-neutral-solid-color);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: var(--brand-neutral-300);
  border-left-style: solid;
  border-left-width: 1px;
  border-top-style: solid;
  border-top-width: 1px;
  display: flex;
  flex: 0 0 auto;
  gap: 6px;
  justify-content: center;
  padding: 12px;
  position: relative;
  width: 100%;
}

.checklist .text-wrapper-4 {
  color: var(--theme-text-primary);
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: normal;
  margin-top: -1px;
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
}

.checklist .frame-4 {
  align-items: center;
  align-self: stretch;
  background-color: var(--brand-neutral-100);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: var(--brand-neutral-300);
  border-left-style: solid;
  border-left-width: 1px;
  border-top-style: solid;
  border-top-width: 1px;
  display: flex;
  gap: 6px;
  height: 50px;
  justify-content: center;
  padding: 12px;
  position: relative;
  width: 100%;
}

.checklist .text-wrapper-5 {
  color: var(--theme-text-secondary);
  font-family: Open Sans variable, Helvetica;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
}

.checklist .frame-5 {
  align-items: center;
  align-self: stretch;
  background-color: var(--theme-background-surface);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: var(--brand-neutral-300);
  border-left-style: solid;
  border-left-width: 1px;
  border-top-style: solid;
  border-top-width: 1px;
  display: flex;
  gap: 6px;
  height: 50px;
  justify-content: center;
  padding: 12px;
  position: relative;
  width: 100%;
}

.checklist .nomenclature {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 155px;
}

.checklist .frame-6 {
  align-items: center;
  align-self: stretch;
  background-color: var(--theme-neutral-solid-color);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: var(--brand-neutral-300);
  border-top-style: solid;
  border-top-width: 1px;
  display: flex;
  flex: 0 0 auto;
  gap: 6px;
  justify-content: center;
  padding: 12px;
  position: relative;
  width: 100%;
}

.checklist .frame-7 {
  align-items: center;
  align-self: stretch;
  background-color: var(--brand-neutral-100);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: var(--brand-neutral-300);
  border-top-style: solid;
  border-top-width: 1px;
  display: flex;
  gap: 6px;
  height: 50px;
  justify-content: center;
  padding: 12px;
  position: relative;
  width: 100%;
}

.checklist .frame-8 {
  align-items: center;
  align-self: stretch;
  background-color: var(--theme-background-surface);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: var(--brand-neutral-300);
  border-top-style: solid;
  border-top-width: 1px;
  display: flex;
  gap: 6px;
  height: 50px;
  justify-content: center;
  padding: 12px;
  position: relative;
  width: 100%;
}

.checklist .frame-9 {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 131px;
}

.checklist .frame-wrapper {
  align-items: center;
  align-self: stretch;
  background-color: var(--brand-neutral-100);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: var(--brand-neutral-300);
  border-top-style: solid;
  border-top-width: 1px;
  display: flex;
  flex: 0 0 auto;
  gap: 6px;
  justify-content: center;
  padding: 12px;
  position: relative;
  width: 100%;
}

.checklist .icons-wrapper {
  align-items: center;
  align-self: stretch;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 10px;
  justify-content: center;
  padding: 1px 0px;
  position: relative;
}

.checklist .icons-7 {
  position: relative !important;
}

.checklist .frame-10 {
  align-items: center;
  align-self: stretch;
  background-color: var(--theme-background-surface);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: var(--brand-neutral-300);
  border-top-style: solid;
  border-top-width: 1px;
  display: flex;
  flex: 0 0 auto;
  gap: 6px;
  justify-content: center;
  padding: 12px;
  position: relative;
  width: 100%;
}

.checklist .frame-11 {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 146px;
}

.checklist .frame-12 {
  align-items: center;
  background-color: var(--theme-neutral-solid-color);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: var(--brand-neutral-300);
  border-top-style: solid;
  border-top-width: 1px;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 6px;
  justify-content: center;
  padding: 12px;
  position: relative;
}

.checklist .frame-13 {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 64px;
}

.checklist .frame-14 {
  align-items: center;
  align-self: stretch;
  background-color: #ffffff;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: var(--brand-neutral-300);
  border-right-style: solid;
  border-right-width: 1px;
  border-top-style: solid;
  border-top-width: 1px;
  display: flex;
  gap: 6px;
  height: 46px;
  justify-content: center;
  padding: 12px;
  position: relative;
  width: 100%;
}

.checklist .frame-15 {
  align-items: center;
  align-self: stretch;
  background-color: var(--brand-neutral-100);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: var(--brand-neutral-300);
  border-right-style: solid;
  border-right-width: 1px;
  border-top-style: solid;
  border-top-width: 1px;
  display: flex;
  gap: 6px;
  height: 50px;
  justify-content: center;
  padding: 12px;
  position: relative;
  width: 100%;
}

.checklist .button-wrapper {
  align-items: center;
  align-self: stretch;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 10px;
  justify-content: center;
  margin-left: -4px;
  margin-right: -4px;
  padding: 1px 0px;
  position: relative;
}

.checklist .button-7 {
  border-radius: var(--border-radius-radius-sm) !important;
  flex: 0 0 auto !important;
  margin-bottom: -12px !important;
  margin-top: -12px !important;
}

.checklist .icons-8 {
  height: 20px !important;
  position: relative !important;
  width: 20px !important;
}

.checklist .frame-16 {
  align-items: center;
  align-self: stretch;
  background-color: var(--theme-background-surface);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: var(--brand-neutral-300);
  border-right-style: solid;
  border-right-width: 1px;
  border-top-style: solid;
  border-top-width: 1px;
  display: flex;
  gap: 6px;
  height: 50px;
  justify-content: center;
  padding: 12px;
  position: relative;
  width: 100%;
}

.checklist .table-header {
    position: 'sticky';
    top: '0px';
}

.checklist .table-header-cell {
  color: var(--theme-text-primary) !important;
  font-family: Open Sans variable, Helvetica !important;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: normal;
  margin-top: -1px;
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
}

.checklist .native-browser-scroll {
  height: 346px !important;
}

.checklist .button-8 {
  all: unset;
  align-items: center;
  border: 1px solid;
  border-color: var(--brand-color);
  border-radius: 6px;
  box-sizing: border-box;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: flex-end;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.checklist .button-9 {
  all: unset;
  box-sizing: border-box;
  color: var(--brand-color);
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.checklist .button-10 {
  all: unset;
  align-items: center;
  background-color: var(--brand-color);
  border-radius: var(--border-radius-radius-sm-duplicate);
  box-sizing: border-box;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: flex-end;
  height: 48px;
  padding: 6px 24px;
  position: relative;
}

.checklist .button-11 {
  all: unset;
  box-sizing: border-box;
  color: var(--theme-primary-solid-color-duplicate);
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.checklist .native-browser-instance {
  height: 646px !important;
  left: 1265px !important;
  position: absolute !important;
  top: 74px !important;
}

.packingList {
  background-color: var(--brand-neutral-100);
  height: 100vh;
  position: relative;
  width: 100%;
}

.packingList .element-logo {
  height: 61px;
  position: relative;
  width: 150px;
}


.packingList .frame {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 16px;
  justify-content: flex-end;
  position: relative;
}

.packingList .button-instance {
  flex: 0 0 auto !important;
}

.packingList .icons-instance {
  height: 20px !important;
  position: relative !important;
  width: 20px !important;
}

.packingList .home-button {
  color: var(--brand-14bis-blue-medium);
  flex: 0 0 auto !important;
}

.packingList .line-desktop-instance {
  align-self: stretch !important;
  flex: 0 0 auto !important;
  width: 100% !important;
}

.packingList .design-component-instance-node {
  background-color: var(--colorbordercard) !important;
}

.packingList .under-banner {
  align-items: center;  /* centers horizontally */
  display: flex;
  flex-direction: column;
  padding: 4px 12px;
  position: absolute;   /* keep if needed for placement */
  top: 70px;
  left: 3%;
  width: 91.8%;
  height: 88vh;
}

.packingList .div {
  background-color: var(--theme-background-surface);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 10px 12px;
  width: 100%; 
  box-sizing: border-box;       
  position: relative; 
  flex: 1 1;            
}

.packingList .breadcrumb {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  gap: 8px;
  justify-content: center;
  padding: 8px 0px;
  position: relative;
  width: 100%;
}

.packingList .breadcrumb-2 {
  align-items: center;
  background-color: var(--theme-primary-solid-color);
  border-radius: 6px;
  box-shadow: inset 0px 2px 2px #00000040;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 4px;
  justify-content: center;
  padding: 8px;
  position: relative;
}

.packingList .button-2 {
  align-items: center;
  background-color: var(--brand-14bis-orange-matte);
  border-radius: 6px 0px 0px 6px;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: center;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.packingList .button-3 {
  all: unset;
  box-sizing: border-box;
  color: #ffffff;
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.packingList .icons-2 {
  color: var(--brand-common-white);
  height: 28px !important;
  position: relative !important;
  width: 28px !important;
}

.packingList .button-4 {
  align-items: center;
  background-color: var(--brand-14bis-orange-matte);
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: center;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.packingList .text-wrapper-2 {
  color: #ffffff;
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.packingList .icons-3 {
  color: var(--brand-common-white);
  height: 28px !important;
  position: relative !important;
  width: 28px !important;
}

.packingList .button-5 {
  align-items: center;
  border: 1px solid;
  border-color: var(--brand-14bis-orange-matte);
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: center;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.packingList .text-wrapper-3 {
  color: var(--brand-14bis-orange-matte);
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.packingList .icons-4 {
  color: var(--brand-14bis-orange-matte);
  height: 28px !important;
  position: relative !important;
  width: 28px !important;
}

.packingList .button-6 {
  align-items: center;
  background-color: var(--theme-primary-solid-disabledbg-duplicate);
  border: 1px solid;
  border-color: #9fa6ad;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: center;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.packingList .text-wrapper-4 {
  color: var(--theme-primary-solid-disabledcolor-duplicate);
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.packingList .icons-5 {
  color: var(--brand-neutral-400);
  height: 28px !important;
  position: relative !important;
  width: 28px !important;
}

.packingList .button-7 {
  align-items: center;
  background-color: var(--theme-primary-solid-disabledbg-duplicate);
  border: 1px solid;
  border-color: #9fa6ad;
  border-radius: 0px var(--border-radius-radius-sm) var(--border-radius-radius-sm) 0px;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: center;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.packingList .icons-6 {
  color: var(--brand-neutral-400);
  height: 28px !important;
  position: relative !important;
  width: 28px !important;
}

.packingList .frame-2 {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  justify-content: flex-end;
  padding: 12px 0px;
  position: relative;
  width: 100%;
}

.packingList .div-2 {
  align-items: flex-start;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
}

.packingList .div-wrapper {
  align-items: center;
  align-self: stretch;
  background-color: var(--theme-neutral-solid-color);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: var(--brand-neutral-300);
  border-left-style: solid;
  border-left-width: 1px;
  border-top-style: solid;
  border-top-width: 1px;
  display: flex;
  flex: 0 0 auto;
  gap: 6px;
  justify-content: center;
  padding: 12px;
  position: relative;
  width: 100%;
}

.packingList .text-wrapper-5 {
  color: var(--theme-text-primary);
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: normal;
  margin-top: -1px;
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
}

.packingList .frame-3 {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  /*border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: var(--brand-neutral-300);
  border-left-style: solid;
  border-left-width: 1px;
  border-right-style: solid;
  border-right-width: 1px;
  border-top-style: solid;
  border-top-width: 1px;*/
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 100%
}

.packingList .name-form{
  padding: 0px 0px 18px 2px;
  display: flex;
  justify-content: space-between; 
  align-items: center;            
  width: 100%;

}

.packingList .left-side {
  display: flex;
  flex-direction: column; /* stack form above paragraph */
  gap: 10px;  
}

.packingList .directions {
  font-size: 12px;
  font-family: "Open Sans variable", Helvetica;
  margin: 0; 
}

.packingList .p-bold {
  font-family: "Open Sans-Bold", Helvetica;
}

.packingList .text-wrapper-6 {
  color: var(--theme-text-secondary);
  font-family: Open Sans variable, Helvetica;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
}

.packingList .frame-4 {
  align-items: center;
  align-self: stretch;
  background-color: var(--theme-neutral-solid-color);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: var(--brand-neutral-300);
  border-top-style: solid;
  border-top-width: 1px;
  display: flex;
  flex: 0 0 auto;
  gap: 6px;
  justify-content: center;
  padding: 12px;
  position: relative;
  width: 100%;
}

.packingList .frame-5 {
  align-items: center;
  align-self: stretch;
  background-color: var(--brand-neutral-100);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: var(--brand-neutral-300);
  border-top-style: solid;
  border-top-width: 1px;
  display: flex;
  gap: 6px;
  height: 50px;
  justify-content: center;
  padding: 12px;
  position: relative;
  width: 100%;
}

.packingList .frame-6 {
  align-items: center;
  align-self: stretch;
  background-color: var(--theme-neutral-solid-color);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: var(--brand-neutral-300);
  border-right-style: solid;
  border-right-width: 1px;
  border-top-style: solid;
  border-top-width: 1px;
  display: flex;
  flex: 0 0 auto;
  gap: 6px;
  justify-content: center;
  padding: 12px;
  position: relative;
  width: 100%;
}

.packingList .frame-7 {
  align-items: center;
  align-self: stretch;
  background-color: var(--brand-neutral-100);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: var(--brand-neutral-300);
  border-right-style: solid;
  border-right-width: 1px;
  border-top-style: solid;
  border-top-width: 1px;
  display: flex;
  gap: 6px;
  height: 50px;
  justify-content: center;
  padding: 12px;
  position: relative;
  width: 100%;
}

.packingList .button-wrapper {
  all: unset;
  align-items: center;
  border: 1px solid;
  border-color: var(--brand-color);
  border-radius: 6px;
  box-sizing: border-box;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: flex-end;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.packingList .button-8 {
  all: unset;
  align-items: center;
  border: 1px solid;
  border-color: var(--brand-color);
  border-radius: 6px;
  box-sizing: border-box;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: flex-end;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.packingList .button-9 {
  all: unset;
  box-sizing: border-box;
  color: var(--brand-color);
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.packingList .button-10 {
  all: unset;
  align-items: center;
  background-color: var(--brand-color);
  border-radius: var(--border-radius-radius-sm-duplicate);
  box-sizing: border-box;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: flex-end;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.packingList .button-11 {
  all: unset;
  box-sizing: border-box;
  color: var(--theme-primary-solid-color-duplicate);
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.containerOverview {
  background-color: var(--brand-neutral-100);
  height: 100vh;
  position: relative;
  width: 100%;
}

.containerOverview .element-logo {
  height: 61px;
  position: relative;
  width: 150px;
}

.containerOverview .frame {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 16px;
  justify-content: flex-end;
  position: relative;
}

.containerOverview .button-instance {
  flex: 0 0 auto !important;
}

.containerOverview .icons-instance {
  height: 20px !important;
  position: relative !important;
  width: 20px !important;
}

.containerOverview .home-button {
  color: var(--brand-14bis-blue-medium);
  flex: 0 0 auto !important;
}

.containerOverview .download-btn {
  height: 28px;
  width: 28px;
  transform: translateY(10px);
  color: var(--brand-14bis-blue-medium);
}

.containerOverview .line-desktop-instance {
  align-self: stretch !important;
  flex: 0 0 auto !important;
  width: 100% !important;
}

.containerOverview .design-component-instance-node {
  background-color: var(--colorbordercard) !important;
}

.containerOverview .under-banner {
  align-items: center;  /* centers horizontally */
  display: flex;
  flex-direction: column;
  padding: 4px 12px;
  position: absolute;   /* keep if needed for placement */
  top: 70px;
  left: 3%;
  width: 91.8%;
  height: 88vh;
}

.containerOverview .div {
  position: absolute;
  width: 91.8%;
  background-color: var(--theme-background-surface);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 10px 12px;
  padding-bottom: 80px;
  width: 100%; 
  box-sizing: border-box;       
  position: relative; 
  flex: 1 1;            
}

.containerOverview .breadcrumb {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  gap: 8px;
  justify-content: center;
  padding: 8px 0px;
  position: relative;
  width: 100%;
}

.containerOverview .breadcrumb-2 {
  align-items: center;
  background-color: var(--theme-primary-solid-color);
  border-radius: 6px;
  box-shadow: inset 0px 2px 2px #00000040;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 4px;
  justify-content: center;
  padding: 8px;
  position: relative;
}

.containerOverview .button-2 {
  align-items: center;
  background-color: var(--brand-14bis-orange-matte);
  border-radius: 6px 0px 0px 6px;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: center;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.containerOverview .button-3 {
  all: unset;
  box-sizing: border-box;
  color: #ffffff;
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.containerOverview .icons-2 {
  color: var(--brand-common-white);
  height: 28px !important;
  position: relative !important;
  width: 28px !important;
}

.containerOverview .button-4 {
  align-items: center;
  background-color: var(--brand-14bis-orange-matte);
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: center;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.containerOverview .text-wrapper-2 {
  color: #ffffff;
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.containerOverview .icons-3 {
  color: var(--brand-common-white);
  height: 28px !important;
  position: relative !important;
  width: 28px !important;
}

.containerOverview .button-4 {
  align-items: center;
  background-color: var(--brand-14bis-orange-matte);
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: center;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.containerOverview .text-wrapper-2 {
  color: #ffffff;
  font-family: Open Sans-SemiBold variable, Helvetica;
;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.containerOverview .button-5 {
  align-items: center;
  border: 1px solid;
  border-color: var(--brand-14bis-orange-matte);
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: center;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.containerOverview .text-wrapper-3 {
  color: var(--brand-14bis-orange-matte);
  font-family: Open Sans-SemiBold variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.containerOverview .icons-4 {
  color: var(--brand-14bis-orange-matte);
  height: 28px !important;
  position: relative !important;
  width: 28px !important;
}

.containerOverview .button-6 {
  align-items: center;
  background-color: var(--theme-primary-solid-disabledbg-duplicate);
  border: 1px solid;
  border-color: #9fa6ad;
  border-radius: 0px var(--border-radius-radius-sm) var(--border-radius-radius-sm) 0px;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: center;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.containerOverview .text-wrapper-4 {
  color: var(--theme-primary-solid-disabledcolor-duplicate);
  font-family: Open Sans-SemiBold variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.containerOverview .icons-5 {
  color: var(--brand-neutral-400);
  height: 28px !important;
  position: relative !important;
  width: 28px !important;
}

.containerOverview .frame-2 {
  align-items: self-start;
  background-color: var(--theme-background-surface);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  width: 100%;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
}

.containerOverview .name-form {
  padding: 0px 0px 0px 8px;
  display: flex;
  justify-content: space-between; 
  align-items: center;            
  width: 100%;
  box-sizing: border-box;
}

.containerOverview .left-side {
  display: flex;
  flex-direction: column; /* stack form above paragraph */
  gap: 10px;  
}

.containerOverview .header-row{
  display: flex;
  align-items: flex-start;
  justify-content: flex-start; 
  gap: 8px;
}

/* Ensure the form doesn't take up 100% width if it's a block element */
.containerOverview .header-row > form {
  display: inline-block;
}
.containerOverview .directions {
  font-size: 12px;
  font-family: "Open Sans variable", Helvetica;
  margin: 0; 
}

.containerOverview .p-bold {
  font-family: "Open Sans-Bold", Helvetica;
}

.containerOverview .div-2 {
  align-items: flex-start;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
}

.containerOverview .container {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 8px;
  position: relative;
}


.containerOverview .tab-2 {
  align-items: center;
  background-color: var(--theme-background-surface);
  border: 1px solid;
  border-color: #cdd7e1;
  border-radius: 6px 6px 0px 0px;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 8px;
  padding: 8px 20px;
  position: relative;
}

.containerOverview .tab-3 {
  align-items: center;
  background-color: var(--theme-background-surface);
  border: 1px solid;
  border-color: #cdd7e1;
  border-radius: 6px 6px var(--border-radius-radius-none) var(--border-radius-radius-none);
  display: inline-flex;
  flex: 0 0 auto;
  gap: 8px;
  padding: 8px 20px;
  position: relative;
}

.containerOverview .divisor {
  height: 1px;
  object-fit: cover;
  position: relative;
  width: 1126px;
}

.containerOverview .table-2 {
  align-items: flex-end;
  display: flex;
  height: 406px;
  position: relative;
  width: 1140px;
}

.containerOverview .nomenclature {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 189px;
}

.containerOverview .div-wrapper {
  align-items: center;
  align-self: stretch;
  background-color: var(--theme-neutral-solid-color);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: var(--brand-neutral-300);
  border-left-style: solid;
  border-left-width: 1px;
  display: flex;
  gap: 6px;
  height: 56px;
  justify-content: center;
  padding: 12px;
  position: relative;
  width: 100%;
}

.containerOverview .frame-3 {
  align-items: start;
  align-self: stretch;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: var(--brand-neutral-300);
  border-left-width: 1px;
  border-top-width: 1px;
  gap: 6px;
  justify-content: center;
  position: relative;
  width: 100%;
}

.containerOverview .positioning-order {
  color: var(--theme-text-primary);
  font-family: Open Sans-Bold variable, Helvetica;

  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 16px;
  margin-top: -1px;
  position: relative;
  text-align: center;
  width: 102px;
}

.containerOverview .frame-11 {
  align-items: flex-start;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
}

.containerOverview .placement-direction {
  color: var(--theme-text-primary);
  font-family: Open Sans-Bold variable, Helvetica;

  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 16px;
  margin-top: -1px;
  position: relative;
  text-align: center;
  width: -moz-fit-content;
  width: fit-content;
}

.containerOverview .vertical-instance {
  margin-bottom: -8px !important;
  margin-top: -8px !important;
  position: relative !important;
}

.containerOverview .frame-12 {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 154px;
}

.containerOverview .button-wrapper {
  all: unset;
  align-items: center;
  border: 1px solid;
  border-color: var(--brand-color);
  border-radius: 6px;
  box-sizing: border-box;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: flex-end;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.containerOverview .button-7 {
  all: unset;
  box-sizing: border-box;
  color: var(--brand-color);
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.containerOverview .button-8 {
    all: unset;
  align-items: center;
  background-color: var(--brand-color);
  border-radius: var(--border-radius-radius-sm-duplicate);
  box-sizing: border-box;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: flex-end;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.containerOverview .button-9 {
  all: unset;
  box-sizing: border-box;
  color: var(--theme-primary-solid-color-duplicate);
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.containerOverview .native-browser-instance {
  height: 646px !important;
  left: 1265px !important;
  position: absolute !important;
  top: 74px !important;
}

.finalpacking {
  background-color: var(--brand-neutral-100);
  height: 100vh;
  position: relative;
  width: 100%;
}

.finalpacking .element-logo {
  height: 61px;
  position: relative;
  width: 150px;
}

.finalpacking .frame {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 16px;
  justify-content: flex-end;
  position: relative;
}

.finalpacking .button-instance {
  flex: 0 0 auto !important;
}

.finalpacking .icons-instance {
  height: 20px !important;
  position: relative !important;
  width: 20px !important;
}

.finalpacking .home-button {
  color: var(--brand-14bis-blue-medium);
  flex: 0 0 auto !important;
}

.finalpacking .expand-button {
  color: var(--brand-14bis-blue-medium);
  flex: 0 0 auto !important;
}

.finalpacking .line-desktop-instance {
  align-self: stretch !important;
  flex: 0 0 auto !important;
  width: 100% !important;
}

.finalpacking .design-component-instance-node {
  flex: 0 0 auto !important;
}

.finalpacking .line-desktop-2 {
  align-self: stretch !important;
  flex: 0 0 auto !important;
  width: 100% !important;
}

.finalpacking .line-desktop-3 {
  background-color: var(--colorbordercard) !important;
}

.finalpacking .under-banner-expand {
  position: absolute;
  top: 70px;
  padding: 4px 12px;
  width: 91.8%;
  height: 100%;
}

.finalpacking .div {
  background-color: var(--theme-background-surface);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 10px 12px;
  padding-bottom: 92px;
  width: 100%; 
  box-sizing: border-box;       
  position: relative; 
  flex: 1 1;            
}
.finalpacking .under-banner{
  align-items: center;  /* centers horizontally */
  display: flex;
  flex-direction: column;
  padding: 4px 12px;
  position: absolute;   /* keep if needed for placement */
  top: 70px;
  left: 3%;
  width: 91.8%;
  height: 88vh;
}

.finalpacking .overlap-group-wrapper {
  height: 591px;
  left: 52px;
  top: 98px;
}

.finalpacking .overlap-group {
  height: 591px;
  position: relative;
}

.finalpacking .frame-wrapper {
  height: 591px;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.finalpacking .frame-2 {
  background-color: var(--theme-background-surface); 
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  height: 95%;
  overflow: hidden;
  padding: 10px 12px;
  position: absolute;
  width: 95%;
  gap: 10px;
}

.finalpacking .frame-2-expand {
  justify-content: space-between;
  background-color: var(--theme-background-surface); 
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: calc(100vh - 90px);
  overflow: hidden;
  padding: 10px 12px;
  position: absolute;
  width: 100%;
  box-sizing: border-box;
  align-items: center; 
}

.finalpacking .breadcrumb {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  gap: 6px;
  justify-content: center;
  padding: 6px 0px;
  position: relative;
  width: 100%;
}

.finalpacking .breadcrumb-2 {
  align-items: center;
  background-color: var(--theme-primary-solid-color);
  border-radius: 6px;
  box-shadow: inset 0px 2px 2px #00000040;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 4px;
  justify-content: center;
  padding: 8px;
  position: relative;
}
.finalpacking .in-line{
  display: flex;
  height: 55vh;
  gap:12px;
  justify-content: space-between;
}

.finalpacking .button-2 {
  align-items: center;
  background-color: var(--brand-14bis-orange-matte);
  border-radius: 6px 0px 0px 6px;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: center;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.finalpacking .button-3 {
  all: unset;
  box-sizing: border-box;
  color: #ffffff;
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.finalpacking .icons-2 {
  color: var(--brand-common-white);
  height: 28px !important;
  position: relative !important;
  width: 28px !important;
}

.finalpacking .button-4 {
  align-items: center;
  background-color: var(--brand-14bis-orange-matte);
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: center;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.finalpacking .text-wrapper-2 {
  color: #ffffff;
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.finalpacking .button-5 {
  align-items: center;
  border: 1px solid;
  border-color: var(--brand-14bis-orange-matte);
  border-radius: 0px 6px 6px 0px;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: center;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.finalpacking .text-wrapper-3 {
  color: var(--brand-14bis-orange-matte);
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.finalpacking .icons-3 {
  color: var(--brand-14bis-orange-matte);
  height: 28px !important;
  position: relative !important;
  width: 28px !important;
}

.finalpacking .element-table {
  align-items: center;
  display: inline-flex;
  gap: 24px;
  height: 406px;
  justify-content: space-between;
  position: relative;
}

.finalpacking .table {
  align-items: flex-start;
  align-self: flex-start;
  flex-direction: column;
  position: relative;
  width: 690px;
  height:200px;
}

.finalpacking .name-form {
  padding: 0px 0px 0px 8px;
  display: flex;
  justify-content: space-between; 
  align-items: center;            
  width: 100%;
  box-sizing: border-box;
}

.finalpacking .left-side {
  display: flex;
  flex-direction: column; /* stack form above paragraph */
  gap: 10px;  
}

.finalpacking .right-side {
  display: inline-flex;
  gap: 12px;  
}

.finalpacking .directions {
  font-size: 12px;
  font-family: "Open Sans variable", Helvetica;
  margin: 0; 
}

.finalpacking .p-bold {
  font-family: "Open Sans-Bold", Helvetica;
}

.finalpacking .tabs {
  align-items: flex-start;
  align-self: stretch;
  border: 0px none;
  border-color: var(--theme-neutral-outlined-border);
  display: flex;
  flex: 0 0 auto;
  position: relative;
  width: 100%;
}

.finalpacking .tab {
  align-items: center;
  background-color: var(--theme-primary-outlined-hoverbg);
  border: 1px solid;
  border-color: var(--brand-14bis-blue-medium);
  border-radius: 6px 6px var(--border-radius-radius-none) var(--border-radius-radius-none);
  display: inline-flex;
  flex: 0 0 auto;
  gap: 8px;
  padding: 8px 20px;
  position: relative;
}

.finalpacking .container {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 8px;
  position: relative;
}

.finalpacking .text-wrapper-4 {
  color: var(--brand-14bis-blue-medium);
  font-family: Open Sans variable, Helvetica;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 27.9px;
  margin-top: -1px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.finalpacking .tab-2 {
  align-items: center;
  background-color: var(--theme-background-surface);
  border: 1px solid;
  border-color: #cdd7e1;
  border-radius: 6px 6px 0px 0px;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 8px;
  padding: 8px 20px;
  position: relative;
}

.finalpacking .text-wrapper-5 {
  color: var(--theme-text-icon);
  font-family: Open Sans variable, Helvetica;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 27.9px;
  margin-top: -1px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.finalpacking .tab-3 {
  align-items: center;
  background-color: var(--theme-background-surface);
  border: 1px solid;
  border-color: #cdd7e1;
  border-radius: 6px 6px var(--border-radius-radius-none) var(--border-radius-radius-none);
  display: inline-flex;
  flex: 0 0 auto;
  gap: 8px;
  padding: 8px 20px;
  position: relative;
}

.finalpacking .line {
  height: 1px;
  object-fit: cover;
  position: relative;
  width: 676px;
}

.finalpacking .table-2 {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  position: relative;
  width: 100%;
}

.finalpacking .frame-3 {
  align-items: flex-start;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
}

.finalpacking .frame-4 {
  align-items: center;
  align-self: stretch;
  background-color: #f5f5f5;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: var(--brand-neutral-300);
  border-left-style: solid;
  border-left-width: 1px;
  display: flex;
  flex: 0 0 auto;
  justify-content: space-between;
  padding: 6px 24px;
  position: relative;
  width: 100%;
}

.finalpacking .text-wrapper-6 {
  color: var(--brand-14bis-blue-medium);
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
}

.finalpacking .icon-wrapper {
  align-items: center;
  border-radius: 6px;
  display: inline-flex;
  flex: 0 0 auto;
  justify-content: center;
  min-height: 48px;
  min-width: 48px;
  position: relative;
}

.finalpacking .div-wrapper {
  align-items: flex-start;
  display: inline-flex;
  flex: 0 0 auto;
  position: relative;
}

.finalpacking .chevron-left-wrapper {
  height: 20px;
  position: relative;
  width: 20px;
}

.finalpacking .chevron-left {
  height: 20px !important;
  left: 0 !important;
  position: absolute !important;
  top: 0 !important;
  transform: rotate(-90deg) !important;
  width: 20px !important;
}

.finalpacking .frame-5 {
  align-items: center;
  align-self: stretch;
  background-color: #f5f5f5;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: var(--brand-neutral-300);
  border-left-style: solid;
  border-left-width: 1px;
  border-top-style: solid;
  border-top-width: 1px;
  display: flex;
  flex: 0 0 auto;
  justify-content: space-between;
  padding: 6px 24px;
  position: relative;
  width: 100%;
}

.finalpacking .frame-6 {
  align-items: center;
  align-self: stretch;
  background-color: var(--theme-primary-outlined-hoverbg);
  border: 1px solid;
  border-color: var(--brand-14bis-blue-light);
  display: flex;
  height: 62px;
  justify-content: space-between;
  padding: 6px 24px;
  position: relative;
  width: 100%;
}

.finalpacking .text-wrapper-7 {
  color: var(--brand-14bis-blue-dark);
  font-family: Open Sans variable, Helvetica;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
}

.finalpacking .native-browser-scroll {
  align-self: stretch !important;
  height: unset !important;
}

.finalpacking .frame-7 {
  margin-left: auto;
  align-items: flex-end;
  flex: 1 1 auto;
  position: relative;
  width: 300px;
  height: 100%;
}

.finalpacking .expanded-box {
  align-items: stretch;
  display: flex;
  flex: 1 1 auto;
  position: relative;
  box-sizing: border-box;
  height: calc(100vh - 100px);


}

.finalpacking .controller-carousel {
  align-items: center;
  display: inline-flex;
  flex-direction: column;
  height: 67px;
  justify-content: space-around;
  position: relative;
}

.finalpacking .direction-container {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  justify-content: space-between;
  position: relative;
  width: 100%;
}

.finalpacking .image {
  height: 300px;
  position: relative;
  width: 300px;
}

.finalpacking .chip-outlined {
  align-items: center;
  background-color: #ffffff;
  border: 0.53px solid;
  border-color: var(--theme-neutral-outlined-border);
  border-radius: 12.76px;
  display: inline-flex;
  gap: 3.19px;
  left: 13px;
  min-height: 14.89px;
  padding: 0px 6.38px;
  position: absolute;
  top: 83px;
}

.finalpacking .p {
  color: var(--theme-neutral-outlined-color);
  font-family: var(--typography-md-500-1-5-font-family);
  font-size: var(--typography-md-500-1-5-font-size);
  font-style: var(--typography-md-500-1-5-font-style);
  font-weight: var(--typography-md-500-1-5-font-weight);
  letter-spacing: var(--typography-md-500-1-5-letter-spacing);
  line-height: var(--typography-md-500-1-5-line-height);
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.finalpacking .span {
  font-family: var(--typography-md-500-1-5-font-family);
  font-size: var(--typography-md-500-1-5-font-size);
  font-style: var(--typography-md-500-1-5-font-style);
  font-weight: var(--typography-md-500-1-5-font-weight);
  letter-spacing: var(--typography-md-500-1-5-letter-spacing);
  line-height: var(--typography-md-500-1-5-line-height);
}

.finalpacking .text-wrapper-8 {
  color: #171a1c;
  font-family: Open Sans variable, Helvetica;
  font-size: 10px;
  font-weight: 600;
  left: 74px;
  letter-spacing: 0;
  line-height: 15px;
  position: absolute;
  top: 108px;
  white-space: nowrap;
}

.finalpacking .text-wrapper-9 {
  color: var(--theme-text-secondary);
  font-family: Open Sans variable, Helvetica;
  font-size: 10px;
  font-weight: 400;
  left: 954px;
  letter-spacing: 0;
  line-height: 15px;
  position: absolute;
  top: 452px;
  white-space: nowrap;
}

.finalpacking .text-wrapper-10 {
  color: var(--theme-text-secondary);
  font-family: Open Sans variable, Helvetica;
  font-size: 10px;
  font-weight: 400;
  left: 866px;
  letter-spacing: 0;
  line-height: 15px;
  position: absolute;
  top: 452px;
  white-space: nowrap;
}

.finalpacking .text-wrapper-11 {
  color: var(--theme-text-secondary);
  font-family: Open Sans variable, Helvetica;
  font-size: 10px;
  font-weight: 400;
  left: 957px;
  letter-spacing: 0;
  line-height: 15px;
  position: absolute;
  top: 231px;
  white-space: nowrap;
}

.finalpacking .button-wrapper {
  all: unset;
  align-items: center;
  border: 1px solid;
  border-color: var(--brand-color);
  border-radius: 6px;
  box-sizing: border-box;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: flex-end;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.finalpacking .button-6 {
  all: unset;
  box-sizing: border-box;
  color: var(--brand-color);
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.finalpacking .button-7 {
  all: unset;
  align-items: center;
  background-color: var(--brand-color);
  border-radius: var(--border-radius-radius-sm-duplicate);
  box-sizing: border-box;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  justify-content: flex-end;
  min-height: 48px;
  padding: 6px 24px;
  position: relative;
}

.finalpacking .button-8 {
  all: unset;
  box-sizing: border-box;
  color: var(--theme-primary-solid-color-duplicate);
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.finalpacking .native-browser-instance {
  height: 646px !important;
  left: 1265px !important;
  position: absolute !important;
  top: 74px !important;
}
.finalpacking .check-table{
  align-items: center;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 24px;
  position: relative;
  width: 100%;
}
.finalpacking .checkmark {
  position: relative !important;
  width: 168px !important;
  overflow-y: hidden;
}
.finalpacking .bold-discription{
  align-self: stretch;
  color: var(--theme-text-primary);
  font-family: Open Sans-Bold variable, Helvetica;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 30px;
  position: relative;
  text-align: center;
}
.finalpacking .discription{
  color: var(--text-secondary, #32383E);
  text-align: center;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.finalpacking .div-3 {
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 12px;
  position: relative;
  width: 597px;
}


.finalpacking .shelf-button-border {
    border: 1px solid #16478e; /* Increased border thickness (from 1px to 2px) */
    border-radius: 8px;
    
    display: inline-flex;
    align-items: center;
    justify-content: center;
    
    background: var(--theme-background-surface);
    position: relative;
    cursor: pointer;

    /* Increased padding creates more space around the icon */
    padding: 16px; 
    
    /* Retain original icon font-size */
    font-size: 28px;
}

.finalpacking .shelf-button-border path {
    fill: #16478e;
}
.finalpacking .shelf-button-border svg {
    width: 28px;
    height: 28px;
    flex-shrink: 0;
}

.finalpacking .icon-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.finalpacking .shelf-icon {
  font-size: 28px;
  padding: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--brand-14bis-blue-medium);
}


.printout {
  align-items: center;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 980px;
  /*height: 842px;*/
  padding: 0px 12px;
  position: relative;
  width: 695px;
}

.printout .page{
  align-items: center;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 18px;
  height: 842px;
  padding: 0px 12px;
  position: relative;
  width: 595px;
}

.printout .frame {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 6px;
  justify-content: center;
  padding: 6px 12px;
  position: relative;
  width: 100%;
}

.printout .frame-2 {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  justify-content: space-between;
  padding: 0px 0px;
  position: relative;
  width: 100%;
}

.printout .headline-copy {
  color: var(--theme-text-primary);
  font-family: "Open Sans-SemiBold", Helvetica;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 30px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.printout .text-wrapper {
  color: #171a1c;
  font-weight: 600;
}

.printout .span {
  color: #31383e;
  font-family: Open Sans variable, Helvetica;
}

.printout .logo-vertical-instance {
  height: 40px !important;
  position: relative !important;
  width: 83px !important;
}

.printout .element-find-the-boxes-for {
  align-self: stretch;
  color: var(--theme-text-secondary);
  font-family: Open Sans variable, Helvetica;  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 12px;
  position: relative;
}

.printout .divider-horizontal-instance {
  align-self: stretch !important;
  flex: 0 0 auto !important;
  width: 100% !important;
}

.printout .frame-3 {
  align-items: flex-start;
  display: flex;
  flex: 0 0 auto;
  justify-content: space-between;
  position: relative;
  width: 545.4px;
}

.printout .div-2 {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 16px;
  position: relative;
}

.printout .text-wrapper-2 {
  color: var(--theme-neutral-outlined-color);
  font-family: Open Sans variable, Helvetica;  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 18px;
  margin-top: -1px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}
 

.printout .overlap-group-wrapper {
  height: 130.97px;
  position: relative;
  width: 127.03px;
}

.printout .overlap-group-2 {
  background-size: 100% 100%;
  height: 136px;
  left: 5px;
  position: relative;
  top: -5px;
  width: 123px;
}

.printout .text-wrapper-3 {
  color: var(--theme-text-secondary);
  font-family: Open Sans variable, Helvetica;  font-size: 4.2px;
  font-weight: 400;
  left: 24px;
  letter-spacing: 0;
  line-height: 6.4px;
  position: absolute;
  top: 122px;
  white-space: nowrap;
}

.printout .text-wrapper-4 {
  color: var(--theme-text-secondary);
  font-family: Open Sans variable, Helvetica;  font-size: 4.2px;
  font-weight: 400;
  left: 77px;
  letter-spacing: 0;
  line-height: 6.4px;
  position: absolute;
  top: 121px;
  white-space: nowrap;
}

.printout .text-wrapper-5 {
  color: var(--theme-text-secondary);
  font-family: Open Sans variable, Helvetica;  font-size: 4.2px;
  font-weight: 400;
  left: 75px;
  letter-spacing: 0;
  line-height: 6.4px;
  position: absolute;
  top: 4px;
  white-space: nowrap;
}

.printout .text-wrapper-6 {
  color: var(--theme-text-secondary);
  font-family: Open Sans variable, Helvetica;  font-size: 4.2px;
  font-weight: 400;
  left: 24px;
  letter-spacing: 0;
  line-height: 6.4px;
  position: absolute;
  top: 5px;
  white-space: nowrap;
}

.printout .frame-4 {
  align-items: flex-start;
  display: flex;
  flex: 0 0 auto;
  gap: 7.94px;
  justify-content: center;
  position: relative;
  width: 378px;
}

.printout .boxes-level {
  align-self: stretch;
  flex: 1 1;
  flex-grow: 1;
  position: relative;
}

.printout .img {
  flex: 1 1;
  flex-grow: 1;
  height: 129.06px;
  position: relative;
}

.printout .boxes-level-2 {
  flex: 1 1;
  flex-grow: 1;
  height: 129.06px;
  object-fit: cover;
  position: relative;
}

.printout .ISU-quadrant {
  color: var(--theme-neutral-outlined-color);
  font-family: Open Sans variable, Helvetica;  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 9px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
  height: 9px;
}

.printout .frame-5 {
  align-items: flex-start;
  display: inline-flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 32px;
  position: relative;
}
.printout .blank{
  height:60px;
  width:100%;
  clear:both;

}

.printout .frame-6 {
  align-items: flex-start;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 16px;
  position: relative;
}

.printout .print {
  height: 82.93px;
  object-fit: cover;
  position: relative;
  width: 270px;
}

.printout .print-2 {
  height: 82.93px;
  position: relative;
  width: 270px;
}

.printout .print-3 {
  height: 82.93px;
  position: relative;
  width: 178.88px;
}

.printout .frame-wrapper {
  align-items: flex-end;
  align-self: stretch;
  background-color: #ffffff;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  position: relative;
  width: 571px;
  left: 40px;
}

.printout .frame-7 {
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  justify-content: space-between;
  position: relative;
  width: 571px;
}

.printout .frame-8 {
  align-items: center;
  align-self: stretch;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 11.28px;
  position: relative;
}

.printout .div-wrapper {
  align-items: center;
  align-self: stretch;
  display: flex;
  gap: 4.84px;
  justify-content: center;
  padding: 9.67px;
  position: relative;
  width: 24px;
}

.printout .text-wrapper-7 {
  color: var(--theme-danger-solid-disabledcolor);
  font-family: Open Sans variable, Helvetica;  font-size: 11.3px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: normal;
  margin-bottom: -2.3px;
  margin-left: -5.67px;
  margin-right: -5.67px;
  margin-top: -3.91px;
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
}

.printout .this-symbol {
  color: var(--theme-text-icon);
  font-family: Open Sans variable, Helvetica;  font-size: 8.1px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  width: 105px;
}

.printout .text-wrapper-8 {
  color: #636b74;
  font-family: Open Sans variable, Helvetica;  font-size: 8.1px;
  font-weight: 400;
  letter-spacing: 0;
}

.printout .text-wrapper-9 {
  font-family: "Open Sans-SemiBold", Helvetica;
  font-weight: 600;
}

.printout .frame-9 {
  align-items: center;
  align-self: stretch;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 8px;
  position: relative;
}

.printout .vertical-instance {
  height: 28.13px !important;
  position: relative !important;
  width: 28.13px !important;
}

.printout .design-component-instance-node {
  height: 28px !important;
  width: 28px !important;
}

.printout .vertical-2 {
  height: 16px !important;
  left: 6px !important;
  width: 16px !important;
}

.printout .vertical-3 {
  height: 16px !important;
  left: 0 !important;
  position: absolute !important;
  top: 0 !important;
  transform: rotate(-180deg) !important;
  width: 16px !important;
}

.printout .vertical-4 {
  height: 16px !important;
  top: 6px !important;
  width: 16px !important;
}

.printout .vertical-5 {
  height: 16px !important;
  left: 0 !important;
  position: absolute !important;
  top: 0 !important;
  transform: rotate(-90deg) !important;
  width: 16px !important;
}

.printout .vertical-6 {
  height: 16px !important;
  left: 6px !important;
  top: 12px !important;
  width: 16px !important;
}

.printout .vertical-7 {
  height: 16px !important;
  left: 12px !important;
  top: 6px !important;
  width: 16px !important;
}

.printout .vertical-8 {
  background-color: var(--theme-danger-solid-disabledcolor) !important;
  height: 7px !important;
  left: 11px !important;
  top: 11px !important;
  width: 7px !important;
}

.printout .p {
  align-self: stretch;
  color: var(--theme-text-icon);
  font-family: Open Sans variable, Helvetica;  font-size: 8.1px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: normal;
  margin-top: -0.81px;
  position: relative;
  width: 108px;
}

.printout .frame-10 {
  align-items: center;
  align-self: stretch;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 14px;
  opacity: 0.8;
  padding: 0px 0px 0px 5px;
  position: relative;
}

.printout .component {
  height: 14.18px !important;
  position: relative !important;
  width: 16.2px !important;
}

.printout .this-symbol-2 {
  color: var(--theme-text-icon);
  font-family: Open Sans variable, Helvetica;  font-size: 8.1px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  width: 110px;
}

.printout .level-canvas {
  height: 186px;
  left: 0;
  object-fit: cover;
  position: fixed;
  top: 0;
  width: 500px;
}

.printout .top{
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 680px;
}

.printout .frame-11 {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  position: relative;
  width: 100%;
}

.printout .frame-11-wrapper {
  align-items: center;
  background-color: #ffffff;
  border: 1px solid;
  border-color: var(--border-radius-borda);
  display: flex;
  gap: 10px;
  height: 30px;
  padding: 10px;
  position: relative;
  width: 680px;
}

.printout .div-2 {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 10px;
  margin-bottom: -3px;
  margin-top: -3px;
  position: relative;
}

.printout .div-2-wrapper {
  align-items: center;
  display: flex;
  position: relative;
  width: 293px;
}

.printout .text-wrapper-10-1 {
  color: #000000;
  font-family: Open Sans variable, Helvetica;  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: normal;
  margin-top: -1px;
  position: relative;
  width: 466px;
  
}

.printout .text-wrapper-10 {
  color: #000000;
  font-family: Open Sans variable, Helvetica;  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: normal;
  margin-top: -1px;
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
}

.printout .frame-12 {
  align-items: center;
  display: flex;
  position: relative;
  width: 36px;
}

.printout .frame-13 {
  align-items: center;
  display: flex;
  position: relative;
  width: 41px;
}

.printout .frame-14 {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  position: relative;
  width: 41px;
}

.printout .frame-15 {
  align-items: center;
  background-color: #ffffff;
  border: 1px solid;
  border-color: var(--border-radius-borda);
  display: flex;
  flex: 1 1;
  flex-grow: 1;
  gap: 10px;
  height: 30px;
  padding: 10px;
  position: relative;
}

.printout .image-ref {
  align-items: center;
  display: flex;
  gap: 10px;
  margin-bottom: -3px;
  margin-left: 5.15px;
  margin-top: -3px;
  position: relative;
  width: 174px;
}
.printout .frame-16 {
  align-items: center;
  display: flex;
  margin-bottom: -3px;
  margin-left: 13px;
  margin-right: -5.15px;
  margin-top: -3px;
  position: relative;
  width: 200px;
}

.printout .frame-17 {
  align-items: center;
  text-align: center;
  display: flex;
  position: relative;
  width: 70px;
}

.printout .frame-18 {
  align-items: center;
  text-align: center;
  display: flex;
  position: relative;
  width: 60px;
}

.printout .vq-st {
  align-items: flex-start;
  display: flex;
  gap: 2px;
  position: relative;
}

.printout .vt-img {
  height: 310px !important;
  z-index: 1;
  position: relative;
  width: 340px !important;
}
.printout .chip{
  position: absolute; 
  top: 6px;
}
.printout .tables {
  align-items: center;
  width: 100%;
}
.printout .div-3 {
  align-items: flex-start;
  display: inline-flex;
  flex: 0 0 auto;
  position: absolute;
}

.printout .div-4 {
  align-items: flex-start;
  display: inline-flex;
  flex: 0 0 auto;
  flex-direction: column;
  position: relative;
  width : 230px;
}

.printout .text-wrapper-3 {
  color: #000000;
  font-family: Open Sans-SemiBold variable, Helvetica;
  font-size: 8px;
  font-weight: 600;
  height: 11px;
  /*left: 60px;*/
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  /*top: 167px;*/
  left: 196px;
  top: 267px;
  transform: rotate(-43deg);
}
.printout .text-wrapper-4 {
  color: #000000;
  font-family: Open Sans-SemiBold variable, Helvetica;
  font-size: 5px;
  font-weight: 600;
  height: 11px;
  /*left: 60px;*/
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  /*top: 167px;*/
  left: 196px;
  top: 140px;
  transform: rotate(-47deg);
}
.printout .frame-footer {
  align-items: flex-start;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 32px;
  position: absolute;
  bottom: 0;
  width: 695px;
}

.backbutton {
  align-self: flex-end;
}

.csvgen {
  display:block;
}

.csvgen .sameType{
  display: flex;
  gap: 10px;
}


.canvasButton {
    color: var(--brand-14bis-blue-medium);
    border-color: var(--brand-color);
    box-sizing: border-box;
    font-family: Open Sans variable, Helvetica;
    border: none;
    background: none;
    font-size: 14px;
    letter-spacing: 0;
    position: relative;
    white-space: nowrap;
    width: -moz-fit-content;
    width: fit-content;
}

.canvasAddonButton {
  color: var(--brand-14bis-blue-medium);
  background-color: var(--brand-14bis-orange-brigh);
  box-sizing: border-box;
  font-family: Open Sans variable, Helvetica;
  border: none;
  font-size: 14px;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.leveltext{
  top:10px;
  color: var(--brand-14bis-blue-medium);
  font-family: Open Sans variable, Helvetica;
  font-size: 14px;
  letter-spacing: 0;
  position: relative;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}

.twoFactor {
  max-width: 400px;
  text-align: center;
  margin: 50px auto;
  font-family: Open Sans variable, Helvetica;

}

.twoFactor .title {
  font-size: 24px;
  margin-bottom: 16px;
  text-align: center;
  font-family: Open Sans variable, Helvetica;
}

.twoFactor .form {
  display: flex;
  flex-direction: column;
}

.twoFactor .input {
  padding: 10px;
  margin-bottom: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: Open Sans variable, Helvetica;

}

.twoFactor .verify-button {
  padding: 10px 16px;
  background-color: var(--brand-14bis-blue-medium);
  font-family: Open Sans variable, Helvetica;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.twoFactor .verify-button:hover {
  background-color: #0056b3;
}

.twoFactor .verify-button.green {
  background-color: #28a745;
}

.twoFactor .verify-button.green:hover {
  background-color: #218838;
}

.twoFactor .verify-button.red {
  background-color: #dc3545;
}

.twoFactor .button.red:hover {
  background-color: #c82333;
}`, "",{"version":3,"sources":["webpack://./src/containers/style.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,gCAAgC;EAChC,8BAA8B;EAC9B,wCAAwC;EACxC,4CAA4C;EAC5C,8CAA8C;EAC9C,+CAA+C;EAC/C,yDAAyD;EACzD,kDAAkD;EAClD,iDAAiD;EACjD,mCAAmC;EACnC,4CAA4C;EAC5C,2CAA2C;EAC3C,2CAA2C;EAC3C,qDAAqD;EACrD,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,0CAA0C;EAC1C,wCAAwC;EACxC,kDAAkD;EAClD,2CAA2C;EAC3C,2CAA2C;EAC3C,wCAAwC;EACxC,kDAAkD;EAClD,uDAAuD;EACvD,wCAAwC;EACxC,yCAAyC;EACzC,iBAAiB;EACjB,qCAAqC;EACrC,oDAAoD;EACpD,gEAAgE;EAChE,+DAA+D;EAC/D,4DAA4D;EAC5D,qDAAqD;EACrD,mEAAmE;EACnE,4DAA4D;EAC5D,wCAAwC;EACxC,2DAA2D;EAC3D,iEAAiE;EACjE,gEAAgE;EAChE,oEAAoE;EACpE,wDAAwD;EACxD,6DAA6D;EAC7D,iEAAiE;EACjE,kDAAkD;EAClD,sDAAsD;EACtD,oEAAoE;EACpE,6DAA6D;EAC7D,iEAAiE;EACjE,2EAA2E;EAC3E,gEAAgE;EAChE,0EAA0E;EAC1E,0DAA0D;EAC1D,oEAAoE;EACpE,6DAA6D;EAC7D,uEAAuE;EACvE,uDAAuD;EACvD,iEAAiE;EACjE,sDAAsD;EACtD,gEAAgE;EAChE,oEAAoE;EACpE,8EAA8E;EAC9E,6DAA6D;EAC7D,uEAAuE;EACvE,iEAAiE;EACjE,gEAAgE;EAChE,6DAA6D;EAC7D,sDAAsD;EACtD,oEAAoE;EACpE,6DAA6D;EAC7D,2CAA2C;EAC3C,wDAAwD;EACxD,iEAAiE;EACjE,gEAAgE;EAChE,6DAA6D;EAC7D,sDAAsD;EACtD,oEAAoE;EACpE,6DAA6D;AAC/D;;AAEA;EACE,oDAAoD;EACpD,gEAAgE;EAChE,+DAA+D;EAC/D,4DAA4D;EAC5D,mEAAmE;EACnE,4DAA4D;EAC5D,wCAAwC;EACxC,iEAAiE;EACjE,gEAAgE;EAChE,oEAAoE;EACpE,6DAA6D;EAC7D,iEAAiE;EACjE,oEAAoE;EACpE,6DAA6D;EAC7D,iEAAiE;EACjE,2EAA2E;EAC3E,gEAAgE;EAChE,0EAA0E;EAC1E,0DAA0D;EAC1D,oEAAoE;EACpE,6DAA6D;EAC7D,uEAAuE;EACvE,uDAAuD;EACvD,iEAAiE;EACjE,oEAAoE;EACpE,8EAA8E;EAC9E,6DAA6D;EAC7D,uEAAuE;EACvE,iEAAiE;EACjE,gEAAgE;EAChE,6DAA6D;EAC7D,oEAAoE;EACpE,6DAA6D;EAC7D,2CAA2C;EAC3C,wDAAwD;EACxD,iEAAiE;EACjE,gEAAgE;EAChE,6DAA6D;EAC7D,oEAAoE;EACpE,6DAA6D;AAC/D;;AAEA;EACE,0EAA0E;EAC1E,+DAA+D;EAC/D,4DAA4D;EAC5D,mEAAmE;EACnE,4DAA4D;EAC5D,yCAAyC;EACzC,2EAA2E;EAC3E,gEAAgE;EAChE,oEAAoE;EACpE,6DAA6D;EAC7D,iEAAiE;EACjE,oEAAoE;EACpE,6DAA6D;EAC7D,2EAA2E;EAC3E,qFAAqF;EACrF,gEAAgE;EAChE,0EAA0E;EAC1E,0DAA0D;EAC1D,oEAAoE;EACpE,6DAA6D;EAC7D,uEAAuE;EACvE,iEAAiE;EACjE,2EAA2E;EAC3E,oEAAoE;EACpE,8EAA8E;EAC9E,6DAA6D;EAC7D,uEAAuE;EACvE,2EAA2E;EAC3E,gEAAgE;EAChE,6DAA6D;EAC7D,oEAAoE;EACpE,6DAA6D;EAC7D,2CAA2C;EAC3C,wDAAwD;EACxD,2EAA2E;EAC3E,gEAAgE;EAChE,6DAA6D;EAC7D,oEAAoE;EACpE,6DAA6D;AAC/D;;AAEA;EACE,+CAA+C;EAC/C,aAAa;EACb,WAAW;AACb;;AAEA;EACE,yDAAkD;EAClD,4BAA4B;EAC5B,sBAAsB;EACtB,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oCAAoC;EACpC,uDAAuD;EACvD,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,cAAc;EACd,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,oEAAoE;EACpE,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;;AAGA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mDAAmD;EACnD,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB,GAAG,yBAAyB;EAC/C,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB,IAAI,iCAAiC;EACvD,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iDAAiD;EACjD,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kDAAkD;EAClD,kBAAkB;EAClB,uCAAuC;EACvC,oBAAoB;EACpB,cAAc;EACd,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,6CAA6C;EAC7C,8BAA8B;EAC9B,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,sCAAsC;EACtC,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iEAAiE;EACjE,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yDAAyD;EACzD,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iEAAiE;EACjE,iBAAiB;EACjB,qBAAqB;EACrB,oFAAoF;EACpF,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAO;EACP,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;;AAErB;AACA;EACE,aAAa;EACb,sBAAsB,EAAE,+BAA+B;EACvD,SAAS;AACX;;AAEA;EACE,eAAe;EACf,4CAA4C;EAC5C,SAAS;AACX;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,QAAQ;AACV;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,oCAAoC;;AAEtC;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;EAClB;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,SAAO;AACT;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,4BAA4B;EAC5B,UAAU;EACV,sBAAsB;EACtB,+BAA+B;EAC/B,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;;AAEf;;AAEA;EACE,+BAA+B;EAC/B,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,yBAAyB;EACzB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oCAAoC;EACpC,uDAAuD;EACvD,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,cAAc;EACd,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;;AAGA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,mBAAmB,GAAG,yBAAyB;EAC/C,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB,IAAI,iCAAiC;EACvD,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iDAAiD;EACjD,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kDAAkD;EAClD,kBAAkB;EAClB,uCAAuC;EACvC,oBAAoB;EACpB,cAAc;EACd,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,8BAA8B;EAC9B,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,cAAc;EACd,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,6CAA6C;EAC7C,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iEAAiE;EACjE,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yDAAyD;EACzD,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iEAAiE;EACjE,iBAAiB;EACjB,qBAAqB;EACrB,oFAAoF;EACpF,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,WAAW;;AAEb;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,+BAA+B;EACvD,SAAS;AACX;;AAEA;EACE,eAAe;EACf,4CAA4C;EAC5C,SAAS;AACX;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kDAAkD;EAClD,0BAA0B;EAC1B,wBAAwB;EACxB,sCAAsC;EACtC,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,QAAQ;EACR,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,0BAA0B;EAC1B,wBAAwB;EACxB,sCAAsC;EACtC,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;EACjD,0BAA0B;EAC1B,wBAAwB;EACxB,sCAAsC;EACtC,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kDAAkD;EAClD,0BAA0B;EAC1B,wBAAwB;EACxB,sCAAsC;EACtC,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,QAAQ;EACR,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,0BAA0B;EAC1B,wBAAwB;EACxB,sCAAsC;EACtC,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;EACjD,0BAA0B;EAC1B,wBAAwB;EACxB,sCAAsC;EACtC,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,0BAA0B;EAC1B,wBAAwB;EACxB,sCAAsC;EACtC,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,QAAQ;EACR,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;EACjD,0BAA0B;EAC1B,wBAAwB;EACxB,sCAAsC;EACtC,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,QAAQ;EACR,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kDAAkD;EAClD,0BAA0B;EAC1B,wBAAwB;EACxB,sCAAsC;EACtC,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;EACd,QAAQ;EACR,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,wBAAwB;EACxB,sCAAsC;EACtC,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,0BAA0B;EAC1B,wBAAwB;EACxB,sCAAsC;EACtC,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wDAAwD;EACxD,yBAAyB;EACzB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;EACjD,0BAA0B;EAC1B,wBAAwB;EACxB,sCAAsC;EACtC,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;EACE,2CAA2C;EAC3C,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,yBAAyB;EACzB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oCAAoC;EACpC,uDAAuD;EACvD,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,iDAAiD;EACjD,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;;AAGA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,mBAAmB,GAAG,yBAAyB;EAC/C,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB,IAAI,iCAAiC;EACvD,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iDAAiD;EACjD,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kDAAkD;EAClD,kBAAkB;EAClB,uCAAuC;EACvC,oBAAoB;EACpB,cAAc;EACd,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,8BAA8B;EAC9B,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,cAAc;EACd,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,6CAA6C;EAC7C,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iEAAiE;EACjE,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yDAAyD;EACzD,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iEAAiE;EACjE,iBAAiB;EACjB,qBAAqB;EACrB,oFAAoF;EACpF,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kDAAkD;EAClD,0BAA0B;EAC1B,wBAAwB;EACxB,sCAAsC;EACtC,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,QAAQ;EACR,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB;;;;;;;;yBAQuB;EACvB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX;AACF;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;;AAEb;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,+BAA+B;EACvD,SAAS;AACX;;AAEA;EACE,eAAe;EACf,4CAA4C;EAC5C,SAAS;AACX;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kDAAkD;EAClD,0BAA0B;EAC1B,wBAAwB;EACxB,sCAAsC;EACtC,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,QAAQ;EACR,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,0BAA0B;EAC1B,wBAAwB;EACxB,sCAAsC;EACtC,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kDAAkD;EAClD,0BAA0B;EAC1B,wBAAwB;EACxB,sCAAsC;EACtC,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,QAAQ;EACR,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,0BAA0B;EAC1B,wBAAwB;EACxB,sCAAsC;EACtC,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,yBAAyB;EACzB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oCAAoC;EACpC,uDAAuD;EACvD,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,iDAAiD;EACjD,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,mBAAmB,GAAG,yBAAyB;EAC/C,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB,IAAI,iCAAiC;EACvD,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iDAAiD;EACjD,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kDAAkD;EAClD,kBAAkB;EAClB,uCAAuC;EACvC,oBAAoB;EACpB,cAAc;EACd,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,8BAA8B;EAC9B,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,cAAc;EACd,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mDAAmD;;EAEnD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,6CAA6C;EAC7C,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iEAAiE;EACjE,iBAAiB;EACjB,qBAAqB;EACrB,oFAAoF;EACpF,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yDAAyD;EACzD,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,iDAAiD;EACjD,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,+BAA+B;EACvD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,QAAQ;AACV;;AAEA,uEAAuE;AACvE;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,4CAA4C;EAC5C,SAAS;AACX;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;;AAGA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,iBAAiB;EACjB,qBAAqB;EACrB,8BAA8B;EAC9B,oBAAoB;EACpB,cAAc;EACd,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,iBAAiB;EACjB,qBAAqB;EACrB,wFAAwF;EACxF,oBAAoB;EACpB,cAAc;EACd,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kDAAkD;EAClD,0BAA0B;EAC1B,wBAAwB;EACxB,sCAAsC;EACtC,wBAAwB;EACxB,sBAAsB;EACtB,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,wBAAwB;EACxB,sCAAsC;EACtC,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,+CAA+C;;EAE/C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,+CAA+C;;EAE/C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,yBAAyB;EACzB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;IACI,UAAU;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,uDAAuD;EACvD,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,iDAAiD;EACjD,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iDAAiD;EACjD,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,SAAO;AACT;AACA;EACE,mBAAmB,GAAG,yBAAyB;EAC/C,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB,IAAI,iCAAiC;EACvD,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,iDAAiD;EACjD,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,iDAAiD;EACjD,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kDAAkD;EAClD,kBAAkB;EAClB,uCAAuC;EACvC,oBAAoB;EACpB,cAAc;EACd,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,YAAY;EACZ,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,8BAA8B;EAC9B,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,cAAc;EACd,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,6CAA6C;EAC7C,8BAA8B;EAC9B,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,+BAA+B;EACvD,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,4CAA4C;EAC5C,SAAS;AACX;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kDAAkD;EAClD,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,uDAAuD;EACvD,iBAAiB;EACjB,4CAA4C;EAC5C,wFAAwF;EACxF,oBAAoB;EACpB,cAAc;EACd,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,iBAAiB;EACjB,qBAAqB;EACrB,8BAA8B;EAC9B,oBAAoB;EACpB,cAAc;EACd,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,iBAAiB;EACjB,qBAAqB;EACrB,wFAAwF;EACxF,oBAAoB;EACpB,cAAc;EACd,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,wBAAwB;EACxB,sCAAsC;EACtC,wBAAwB;EACxB,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,wBAAwB;EACxB,sCAAsC;EACtC,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,uDAAuD;EACvD,iBAAiB;EACjB,2CAA2C;EAC3C,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;;;AAG7B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,kDAAkD;EAClD,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,0CAA0C;EAC1C,qDAAqD;EACrD,iDAAiD;EACjD,mDAAmD;EACnD,qDAAqD;EACrD,2DAA2D;EAC3D,qDAAqD;EACrD,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,iDAAiD;EACjD,mDAAmD;EACnD,qDAAqD;EACrD,2DAA2D;EAC3D,qDAAqD;AACvD;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,yBAAyB;EACzB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oCAAoC;EACpC,uDAAuD;EACvD,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,iDAAiD;EACjD,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,6CAA6C;EAC7C,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,YAAY;AACd;;;AAGA;IACI,yBAAyB,EAAE,iDAAiD;IAC5E,kBAAkB;;IAElB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;;IAEvB,2CAA2C;IAC3C,kBAAkB;IAClB,eAAe;;IAEf,yDAAyD;IACzD,aAAa;;IAEb,mCAAmC;IACnC,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;;AAGA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,4CAA4C;EAC5C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,0CAA0C,GAAG,eAAe;EAC5D,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C,GAAG,eAAe;EAC5D,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;;AAGA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,0CAA0C,GAAG,gBAAgB;EAC7D,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,0CAA0C,GAAG,gBAAgB;EAC7D,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,0CAA0C,GAAG,gBAAgB;EAC7D,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,0CAA0C,GAAG,gBAAgB;EAC7D,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,SAAO;EACP,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C,GAAG,eAAe;EAC5D,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,UAAU;EACV,UAAU;;AAEZ;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,8CAA8C;EAC9C,0CAA0C,GAAG,iBAAiB;EAC9D,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,0CAA0C,GAAG,gBAAgB;EAC7D,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,0CAA0C,GAAG,gBAAgB;EAC7D,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,oEAAoE;EACpE,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,0CAA0C,GAAG,gBAAgB;EAC7D,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,0CAA0C,GAAG,gBAAgB;EAC7D,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,OAAO;EACP,iBAAiB;EACjB,eAAe;EACf,MAAM;EACN,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,wCAAwC;EACxC,aAAa;EACb,SAAS;EACT,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,0CAA0C,GAAG,eAAe;EAC5D,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;;AAEd;;AAEA;EACE,cAAc;EACd,0CAA0C,GAAG,eAAe;EAC5D,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,wCAAwC;EACxC,aAAa;EACb,SAAO;EACP,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mDAAmD;EACnD,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,mDAAmD;EACnD,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;;AAGA;IACI,qCAAqC;IACrC,gCAAgC;IAChC,sBAAsB;IACtB,0CAA0C;IAC1C,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA;EACE,qCAAqC;EACrC,iDAAiD;EACjD,sBAAsB;EACtB,0CAA0C;EAC1C,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,qCAAqC;EACrC,0CAA0C;EAC1C,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,0CAA0C;;AAE5C;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;;AAE5C;;AAEA;EACE,kBAAkB;EAClB,gDAAgD;EAChD,0CAA0C;EAC1C,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[":root {\n  --border-radius-borda: rgb(231, 231, 231);\n  --border-radius-radius-none: 0px;\n  --border-radius-radius-sm: 6px;\n  --border-radius-radius-sm-duplicate: 6px;\n  --brand-14bis-blue-dark: rgba(24, 40, 87, 1);\n  --brand-14bis-blue-light: rgba(0, 113, 186, 1);\n  --brand-14bis-blue-medium: rgba(22, 71, 142, 1);\n  --brand-14bis-blue-medium-duplicate: rgba(22, 71, 142, 1);\n  --brand-14bis-orange-bright: rgba(242, 101, 34, 1);\n  --brand-14bis-orange-matte: rgba(228, 129, 58, 1);\n  --brand-color: rgba(0, 113, 186, 1);\n  --brand-common-white: rgba(255, 255, 255, 1);\n  --brand-neutral-050: rgba(251, 252, 254, 1);\n  --brand-neutral-100: rgba(240, 244, 248, 1);\n  --brand-neutral-100-duplicate: rgba(240, 244, 248, 1);\n  --brand-neutral-200: rgba(221, 231, 238, 1);\n  --brand-neutral-300: rgba(205, 215, 225, 1);\n  --brand-neutral-400: rgba(159, 166, 173, 1);\n  --brand-neutral-500: rgba(99, 107, 116, 1);\n  --brand-neutral-800: rgba(23, 26, 28, 1);\n  --brand-neutral-800-duplicate: rgba(23, 26, 28, 1);\n  --brand-primary-050: rgba(237, 245, 253, 1);\n  --brand-primary-100: rgba(227, 239, 251, 1);\n  --brand-primary-800: rgba(10, 39, 68, 1);\n  --brand-primary-800-duplicate: rgba(10, 39, 68, 1);\n  --coloractioncontainersecondary: rgba(255, 255, 255, 1);\n  --colorborderactive: rgba(51, 51, 51, 1);\n  --colorbordercard: rgba(230, 230, 230, 1);\n  --spacing-2: 16px;\n  --spacing-brand: rgba(0, 113, 186, 1);\n  --theme-background-surface: var(--brand-neutral-050);\n  --theme-danger-outlined-disabledborder: var(--brand-neutral-200);\n  --theme-danger-outlined-disabledcolor: var(--brand-neutral-400);\n  --theme-danger-plain-disabledcolor: var(--brand-neutral-400);\n  --theme-danger-solid-color: var(--brand-common-white);\n  --theme-danger-solid-disabledbg: var(--brand-neutral-100-duplicate);\n  --theme-danger-solid-disabledcolor: var(--brand-neutral-400);\n  --theme-divider: rgba(99, 107, 116, 0.3);\n  --theme-neutral-outlined-activebg: var(--brand-neutral-200);\n  --theme-neutral-outlined-disabledborder: var(--brand-neutral-200);\n  --theme-neutral-outlined-disabledcolor: var(--brand-neutral-400);\n  --theme-neutral-outlined-hoverbg: var(--brand-neutral-100-duplicate);\n  --theme-neutral-plain-activebg: var(--brand-neutral-200);\n  --theme-neutral-plain-disabledcolor: var(--brand-neutral-400);\n  --theme-neutral-plain-hoverbg: var(--brand-neutral-100-duplicate);\n  --theme-neutral-solid-bg: var(--brand-neutral-500);\n  --theme-neutral-solid-color: var(--brand-common-white);\n  --theme-neutral-solid-disabledbg: var(--brand-neutral-100-duplicate);\n  --theme-neutral-solid-disabledcolor: var(--brand-neutral-400);\n  --theme-primary-outlined-disabledborder: var(--brand-neutral-200);\n  --theme-primary-outlined-disabledborder-duplicate: var(--brand-neutral-200);\n  --theme-primary-outlined-disabledcolor: var(--brand-neutral-400);\n  --theme-primary-outlined-disabledcolor-duplicate: var(--brand-neutral-400);\n  --theme-primary-outlined-hoverbg: var(--brand-primary-100);\n  --theme-primary-outlined-hoverbg-duplicate: var(--brand-primary-100);\n  --theme-primary-plain-disabledcolor: var(--brand-neutral-400);\n  --theme-primary-plain-disabledcolor-duplicate: var(--brand-neutral-400);\n  --theme-primary-plain-hoverbg: var(--brand-primary-050);\n  --theme-primary-plain-hoverbg-duplicate: var(--brand-primary-050);\n  --theme-primary-solid-color: var(--brand-common-white);\n  --theme-primary-solid-color-duplicate: var(--brand-common-white);\n  --theme-primary-solid-disabledbg: var(--brand-neutral-100-duplicate);\n  --theme-primary-solid-disabledbg-duplicate: var(--brand-neutral-100-duplicate);\n  --theme-primary-solid-disabledcolor: var(--brand-neutral-400);\n  --theme-primary-solid-disabledcolor-duplicate: var(--brand-neutral-400);\n  --theme-success-outlined-disabledborder: var(--brand-neutral-200);\n  --theme-success-outlined-disabledcolor: var(--brand-neutral-400);\n  --theme-success-plain-disabledcolor: var(--brand-neutral-400);\n  --theme-success-solid-color: var(--brand-common-white);\n  --theme-success-solid-disabledbg: var(--brand-neutral-100-duplicate);\n  --theme-success-solid-disabledcolor: var(--brand-neutral-400);\n  --theme-text-icon: var(--brand-neutral-500);\n  --theme-text-primary: var(--brand-neutral-800-duplicate);\n  --theme-warning-outlined-disabledborder: var(--brand-neutral-200);\n  --theme-warning-outlined-disabledcolor: var(--brand-neutral-400);\n  --theme-warning-plain-disabledcolor: var(--brand-neutral-400);\n  --theme-warning-solid-color: var(--brand-common-white);\n  --theme-warning-solid-disabledbg: var(--brand-neutral-100-duplicate);\n  --theme-warning-solid-disabledcolor: var(--brand-neutral-400);\n}\n\n[data-theme-mode=\"light\"] {\n  --theme-background-surface: var(--brand-neutral-050);\n  --theme-danger-outlined-disabledborder: var(--brand-neutral-200);\n  --theme-danger-outlined-disabledcolor: var(--brand-neutral-400);\n  --theme-danger-plain-disabledcolor: var(--brand-neutral-400);\n  --theme-danger-solid-disabledbg: var(--brand-neutral-100-duplicate);\n  --theme-danger-solid-disabledcolor: var(--brand-neutral-400);\n  --theme-divider: rgba(99, 107, 116, 0.3);\n  --theme-neutral-outlined-disabledborder: var(--brand-neutral-200);\n  --theme-neutral-outlined-disabledcolor: var(--brand-neutral-400);\n  --theme-neutral-outlined-hoverbg: var(--brand-neutral-100-duplicate);\n  --theme-neutral-plain-disabledcolor: var(--brand-neutral-400);\n  --theme-neutral-plain-hoverbg: var(--brand-neutral-100-duplicate);\n  --theme-neutral-solid-disabledbg: var(--brand-neutral-100-duplicate);\n  --theme-neutral-solid-disabledcolor: var(--brand-neutral-400);\n  --theme-primary-outlined-disabledborder: var(--brand-neutral-200);\n  --theme-primary-outlined-disabledborder-duplicate: var(--brand-neutral-200);\n  --theme-primary-outlined-disabledcolor: var(--brand-neutral-400);\n  --theme-primary-outlined-disabledcolor-duplicate: var(--brand-neutral-400);\n  --theme-primary-outlined-hoverbg: var(--brand-primary-100);\n  --theme-primary-outlined-hoverbg-duplicate: var(--brand-primary-100);\n  --theme-primary-plain-disabledcolor: var(--brand-neutral-400);\n  --theme-primary-plain-disabledcolor-duplicate: var(--brand-neutral-400);\n  --theme-primary-plain-hoverbg: var(--brand-primary-050);\n  --theme-primary-plain-hoverbg-duplicate: var(--brand-primary-050);\n  --theme-primary-solid-disabledbg: var(--brand-neutral-100-duplicate);\n  --theme-primary-solid-disabledbg-duplicate: var(--brand-neutral-100-duplicate);\n  --theme-primary-solid-disabledcolor: var(--brand-neutral-400);\n  --theme-primary-solid-disabledcolor-duplicate: var(--brand-neutral-400);\n  --theme-success-outlined-disabledborder: var(--brand-neutral-200);\n  --theme-success-outlined-disabledcolor: var(--brand-neutral-400);\n  --theme-success-plain-disabledcolor: var(--brand-neutral-400);\n  --theme-success-solid-disabledbg: var(--brand-neutral-100-duplicate);\n  --theme-success-solid-disabledcolor: var(--brand-neutral-400);\n  --theme-text-icon: var(--brand-neutral-500);\n  --theme-text-primary: var(--brand-neutral-800-duplicate);\n  --theme-warning-outlined-disabledborder: var(--brand-neutral-200);\n  --theme-warning-outlined-disabledcolor: var(--brand-neutral-400);\n  --theme-warning-plain-disabledcolor: var(--brand-neutral-400);\n  --theme-warning-solid-disabledbg: var(--brand-neutral-100-duplicate);\n  --theme-warning-solid-disabledcolor: var(--brand-neutral-400);\n}\n\n[data-theme-mode=\"dark\"] {\n  --theme-danger-outlined-disabledborder: var(--brand-neutral-800-duplicate);\n  --theme-danger-outlined-disabledcolor: var(--brand-neutral-500);\n  --theme-danger-plain-disabledcolor: var(--brand-neutral-500);\n  --theme-danger-solid-disabledbg: var(--brand-neutral-800-duplicate);\n  --theme-danger-solid-disabledcolor: var(--brand-neutral-500);\n  --theme-divider: rgba(99, 107, 116, 0.16);\n  --theme-neutral-outlined-disabledborder: var(--brand-neutral-800-duplicate);\n  --theme-neutral-outlined-disabledcolor: var(--brand-neutral-500);\n  --theme-neutral-outlined-hoverbg: var(--brand-neutral-800-duplicate);\n  --theme-neutral-plain-disabledcolor: var(--brand-neutral-500);\n  --theme-neutral-plain-hoverbg: var(--brand-neutral-800-duplicate);\n  --theme-neutral-solid-disabledbg: var(--brand-neutral-800-duplicate);\n  --theme-neutral-solid-disabledcolor: var(--brand-neutral-500);\n  --theme-primary-outlined-disabledborder: var(--brand-neutral-800-duplicate);\n  --theme-primary-outlined-disabledborder-duplicate: var(--brand-neutral-800-duplicate);\n  --theme-primary-outlined-disabledcolor: var(--brand-neutral-500);\n  --theme-primary-outlined-disabledcolor-duplicate: var(--brand-neutral-500);\n  --theme-primary-outlined-hoverbg: var(--brand-primary-800);\n  --theme-primary-outlined-hoverbg-duplicate: var(--brand-primary-800);\n  --theme-primary-plain-disabledcolor: var(--brand-neutral-500);\n  --theme-primary-plain-disabledcolor-duplicate: var(--brand-neutral-500);\n  --theme-primary-plain-hoverbg: var(--brand-primary-800-duplicate);\n  --theme-primary-plain-hoverbg-duplicate: var(--brand-primary-800-duplicate);\n  --theme-primary-solid-disabledbg: var(--brand-neutral-800-duplicate);\n  --theme-primary-solid-disabledbg-duplicate: var(--brand-neutral-800-duplicate);\n  --theme-primary-solid-disabledcolor: var(--brand-neutral-500);\n  --theme-primary-solid-disabledcolor-duplicate: var(--brand-neutral-500);\n  --theme-success-outlined-disabledborder: var(--brand-neutral-800-duplicate);\n  --theme-success-outlined-disabledcolor: var(--brand-neutral-500);\n  --theme-success-plain-disabledcolor: var(--brand-neutral-500);\n  --theme-success-solid-disabledbg: var(--brand-neutral-800-duplicate);\n  --theme-success-solid-disabledcolor: var(--brand-neutral-500);\n  --theme-text-icon: var(--brand-neutral-400);\n  --theme-text-primary: var(--brand-neutral-100-duplicate);\n  --theme-warning-outlined-disabledborder: var(--brand-neutral-800-duplicate);\n  --theme-warning-outlined-disabledcolor: var(--brand-neutral-500);\n  --theme-warning-plain-disabledcolor: var(--brand-neutral-500);\n  --theme-warning-solid-disabledbg: var(--brand-neutral-800-duplicate);\n  --theme-warning-solid-disabledcolor: var(--brand-neutral-500);\n}\n\n.menu-landing {\n  background-color: var(--brand-14bis-blue-light);\n  height: 100vh;\n  width: 100%;\n}\n\n.menu-landing .overlap-group {\n  background-image: url(../assets/menu_backdrop.png);\n  background-position: 50% 50%;\n  background-size: cover;\n  background-repeat: no-repeat;\n  height: 100%;\n  position: relative;\n}\n\n.menu-landing .element-logo {\n  height: 61px;\n  position: relative;\n  width: 150px;\n}\n\n.menu-landing .frame {\n  align-items: center;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 16px;\n  justify-content: flex-end;\n  position: relative;\n}\n\n.menu-landing .button-instance {\n  flex: 0 0 auto !important;\n}\n\n.menu-landing .home-button {\n  color: var(--brand-14bis-blue-medium);\n  flex: 0 0 auto !important;\n}\n\n.menu-landing .line-desktop-instance {\n  align-self: stretch !important;\n  flex: 0 0 auto !important;\n  width: 100% !important;\n}\n\n.menu-landing .design-component-instance-node {\n  background-color: var(--colorbordercard) !important;\n}\n\n.menu-landing .start {\n  align-items: flex-start;\n  display: inline-flex;\n  flex-direction: column;\n  left: 52px;\n  position: absolute;\n  top: 273px;\n}\n\n.menu-landing .trust-security-and {\n  color: var(--theme-primary-solid-color);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 36px;\n  font-weight: 700;\n  letter-spacing: 0px;\n  line-height: 46.8px;\n  margin-top: -1px;\n  position: relative;\n  width: 298px;\n}\n\n.menu-landing .span {\n  font-weight: 700;\n}\n\n.menu-landing .text-wrapper-2 {\n  color: #fff;\n  font-family: Open Sans variable, Helvetica;\n  font-size: 36px;\n  font-weight: 400;\n  letter-spacing: 0 px;\n  line-height: 46.8px;\n}\n\n.menu-landing .div {\n  align-items: flex-start;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  position: relative;\n}\n\n.menu-landing .button-wrapper {\n  all: unset;\n  align-items: center;\n  background-color: var(--brand-color);\n  border-radius: var(--border-radius-radius-sm-duplicate);\n  box-sizing: border-box;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: center;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.menu-landing .button-2 {\n  all: unset;\n  box-sizing: border-box;\n  color: #ffffff;\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.menu-landing .div-wrapper {\n  all: unset;\n  align-items: center;\n  border: 1px solid;\n  border-color: var(--theme-primary-outlined-disabledborder-duplicate);\n  border-radius: 6px;\n  box-sizing: border-box;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: center;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.menu-landing .button-3 {\n  all: unset;\n  box-sizing: border-box;\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.menu-landing button:not([disabled]) .button-3 {\n  color: #ffffff !important;\n}\n\n.menu-landing button[disabled] .button-3 {\n  color: var(--theme-primary-outlined-disabledcolor-duplicate) !important;\n}\n\n.upload-file {\n  background-color: var(--brand-neutral-100);\n  height: 100vh;\n  position: relative;\n  width: 100%;\n}\n\n\n.upload-file .element-logo {\n  height: 61px;\n  position: relative;\n  width: 150px;\n}\n\n.upload-file .frame {\n  align-items: center;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 16px;\n  justify-content: flex-end;\n  position: relative;\n}\n\n.upload-file .button-instance {\n  flex: 0 0 auto !important;\n}\n\n\n.upload-file .home-button {\n  color: var(--brand-14bis-blue-medium);\n  flex: 0 0 auto !important;\n}\n\n.upload-file .line-desktop-instance {\n  align-self: stretch !important;\n  flex: 0 0 auto !important;\n  width: 100% !important;\n}\n\n.upload-file .design-component-instance-node {\n  background-color: var(--colorbordercard) !important;\n  width: 100%;\n  height: 100%;\n}\n\n.upload-file .under-banner {\n  align-items: center;  /* centers horizontally */\n  display: flex;\n  flex-direction: column;\n  padding: 4px 12px;\n  position: absolute;   /* keep if needed for placement */\n  top: 70px;\n  left: 3%;\n  width: 91.8%;\n  height: 88vh;\n}\n\n.upload-file .div {\n  position: absolute;\n  width: 91.8%;\n  background-color: var(--theme-background-surface);\n  border-radius: 6px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding: 10px 12px;\n  padding-bottom: 80px;\n  width: 100%; \n  box-sizing: border-box;       \n  position: relative; \n  flex: 1; \n}\n\n.upload-file .breadcrumb {\n  align-items: center;\n  align-self: stretch;\n  display: flex;\n  flex: none;\n  gap: 8px;\n  justify-content: center;\n  padding: 8px 0px;\n  position: relative;\n  width: 100%;\n}\n\n.upload-file .breadcrumb-2 {\n  align-items: center;\n  background-color: var(--theme-primary-solid-color);\n  border-radius: 6px;\n  box-shadow: inset 0px 2px 2px #00000040;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 4px;\n  justify-content: center;\n  padding: 8px;\n  position: relative;\n}\n\n.upload-file .button-2 {\n  align-items: center;\n  border: 1px solid;\n  border-color: var(--brand-14bis-orange-matte);\n  border-radius: 6px 0px 0px 6px;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: center;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.upload-file .button-3 {\n  all: unset;\n  box-sizing: border-box;\n  color: var(--brand-14bis-orange-matte);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.upload-file .icons-2 {\n  color: var(--brand-14bis-orange-matte);\n  height: 28px !important;\n  position: relative !important;\n  width: 28px !important;\n}\n\n.upload-file .button-4 {\n  align-items: center;\n  background-color: var(--theme-primary-solid-disabledbg-duplicate);\n  border: 1px solid;\n  border-color: #9fa6ad;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: center;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.upload-file .text-wrapper-2 {\n  color: var(--theme-primary-solid-disabledcolor-duplicate);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.upload-file .icons-3 {\n  color: var(--brand-neutral-400);\n  height: 28px !important;\n  position: relative !important;\n  width: 28px !important;\n}\n\n.upload-file .icons-4 {\n  color: var(--brand-neutral-400);\n  height: 28px !important;\n  position: relative !important;\n  width: 28px !important;\n}\n\n.upload-file .icons-5 {\n  color: var(--brand-neutral-400);\n  height: 28px !important;\n  position: relative !important;\n  width: 28px !important;\n}\n\n.upload-file .button-5 {\n  align-items: center;\n  background-color: var(--theme-primary-solid-disabledbg-duplicate);\n  border: 1px solid;\n  border-color: #9fa6ad;\n  border-radius: 0px var(--border-radius-radius-sm) var(--border-radius-radius-sm) 0px;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: center;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.upload-file .icons-6 {\n  color: var(--brand-neutral-400);\n  height: 28px !important;\n  position: relative !important;\n  width: 28px !important;\n}\n\n.upload-file .upload-image-default {\n  align-items: stretch;\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n  min-height: 0;\n  flex: 1;\n}\n\n.upload-file .adicionar-novo-job {\n  border-radius: 4px;\n  display: flex;\n  flex: 1;\n  flex-direction:column;\n  flex-grow: 1;\n  gap: 24px;\n  justify-content: center;\n  padding: 16px;\n  position: relative;\n  min-height: 0;\n}\n.upload-file .name-form{\n  display: flex;\n  justify-content:flex-start;\n  padding: 0px;\n  align-items: flex-start;\n  align-self: stretch;\n\n}\n.upload-file .left-side {\n  display: flex;\n  flex-direction: column; /* stack form above paragraph */\n  gap: 10px;  \n}\n\n.upload-file .directions {\n  font-size: 12px;\n  font-family: \"Open Sans variable\", Helvetica;\n  margin: 0; \n}\n\n.upload-file .p-bold {\n  font-family: \"Open Sans-Bold\", Helvetica;\n}\n\n.upload-file .upload-button{\n  align-items: center;\n  align-self: stretch;\n  flex: 1;\n  flex-grow: 1;\n  justify-content: center;\n  position: relative;\n  padding: 0px;\n  border-radius: 4px;\n}\n\n.upload-file .list-scroll{\n  margin: 0px; \n  padding: 0px; \n  display: inline;\n  width: 100%;\n  max-height: 200px;\n  overflow-y: auto;\n  gap: 8px;\n}\n.upload-file .uploadButton-and-files-container{\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 16px;\n  align-items: center;\n  flex: 1;\n  min-height: 0;\n  align-self: stretch;\n  background: var(--Grey-200, #E8E8E8);\n\n}\n.upload-file .card-add-product {\n  align-items: center;\n  align-self: stretch;\n  background-color: #ffffff;\n  border: 1px dashed;\n  border-color: var(--brand-neutral-300);\n  border-radius: 4px;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  flex-grow: 1;\n  float: left;\n  gap: 8px;\n  justify-content: center;\n  position: relative;\n  }\n\n.upload-file .upload-instructions {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.upload-file .uploaded-files{\n  display: flex;\n  padding: 16px 8px;\n  align-items: center;\n  gap: 8px;\n  align-self: stretch;\n  background-color: #ffffff;\n  border: 1px dashed;\n  border-color: var(--brand-neutral-300);\n  border-radius: 4px;\n  display: flex;\n  flex: 1;\n}\n\n.upload-file .metricswitch {\n  left: -9999px;\n  display:none;\n  visibility:hidden !important;\n  all: unset;\n  box-sizing: border-box;\n  color: var(--brand-neutral-500);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  clear: left;\n  position: absolute;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.upload-file .icons-7 {\n  color: var(--brand-14bis-blue-medium);\n  position: relative !important;\n}\n.upload-file .icons-8 {\n  padding: 8px;\n  color: var(--theme-text-primary);\n}\n\n.upload-file .delete-icon {\n  margin-left: auto;\n  color:var(--brand-14bis-orange-bright);\n  cursor: pointer;\n  padding: 8px;\n}\n\n.upload-file .delete-icon:hover {\n  color:#c82333;\n\n}\n\n.upload-file .p {\n  color: var(--brand-neutral-800);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 12px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 15.6px;\n  position: relative;\n  text-align: center;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.upload-file .button-wrapper {\n  all: unset;\n  align-items: center;\n  border: 1px solid;\n  border-color: var(--brand-color);\n  border-radius: 6px;\n  box-sizing: border-box;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: flex-end;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.upload-file .button-6 {\n  all: unset;\n  box-sizing: border-box;\n  color: var(--brand-color);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.upload-file .div-wrapper {\n  all: unset;\n  align-items: center;\n  background-color: var(--brand-color);\n  border-radius: var(--border-radius-radius-sm-duplicate);\n  box-sizing: border-box;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: flex-end;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.upload-file .button-7 {\n  all: unset;\n  box-sizing: border-box;\n  color: #ffffff;\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.checklist {\n  background-color: var(--brand-neutral-100);\n  height: 100vh;\n  position: relative;\n  width: 100%;\n}\n\n\n.checklist .element-logo {\n  height: 61px;\n  position: relative;\n  width: 150px;\n}\n\n.checklist .frame {\n  align-items: center;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 16px;\n  justify-content: flex-end;\n  position: relative;\n}\n\n.checklist .button-instance {\n  flex: 0 0 auto !important;\n}\n\n.checklist .line-desktop-instance {\n  align-self: stretch !important;\n  flex: 0 0 auto !important;\n  width: 100% !important;\n}\n\n.checklist .design-component-instance-node {\n  background-color: var(--colorbordercard) !important;\n}\n\n.checklist .under-banner {\n  align-items: center;  /* centers horizontally */\n  display: flex;\n  flex-direction: column;\n  padding: 4px 12px;\n  position: absolute;   /* keep if needed for placement */\n  top: 70px;\n  left: 3%;\n  width: 91.8%;\n  height: 88vh;\n}\n\n.checklist .div {\n  background-color: var(--theme-background-surface);\n  border-radius: 6px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding: 10px 12px;\n  padding-bottom: 92px;\n  width: 100%; \n  box-sizing: border-box;       \n  position: relative; \n  flex: 1;          \n}\n\n.checklist .breadcrumb {\n  align-items: center;\n  align-self: stretch;\n  display: flex;\n  flex: 0 0 auto;\n  gap: 8px;\n  justify-content: center;\n  padding: 8px 0px;\n  position: relative;\n  width: 100%;\n}\n\n.checklist .breadcrumb-2 {\n  align-items: center;\n  background-color: var(--theme-primary-solid-color);\n  border-radius: 6px;\n  box-shadow: inset 0px 2px 2px #00000040;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 4px;\n  justify-content: center;\n  padding: 8px;\n  position: relative;\n}\n\n.checklist .button-2 {\n  align-items: center;\n  background-color: var(--brand-14bis-orange-matte);\n  border-radius: 6px 0px 0px 6px;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: center;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.checklist .button-3 {\n  all: unset;\n  box-sizing: border-box;\n  color: #ffffff;\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.checklist .icons-2 {\n  color: var(--brand-common-white);\n  height: 28px !important;\n  position: relative !important;\n  width: 28px !important;\n}\n\n.checklist .button-4 {\n  align-items: center;\n  border: 1px solid;\n  border-color: var(--brand-14bis-orange-matte);\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: center;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.checklist .text-wrapper-2 {\n  color: var(--brand-14bis-orange-matte);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.checklist .icons-3 {\n  color: var(--brand-14bis-orange-matte);\n  height: 28px !important;\n  position: relative !important;\n  width: 28px !important;\n}\n\n.checklist .button-5 {\n  align-items: center;\n  background-color: var(--theme-primary-solid-disabledbg-duplicate);\n  border: 1px solid;\n  border-color: #9fa6ad;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: center;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.checklist .text-wrapper-3 {\n  color: var(--theme-primary-solid-disabledcolor-duplicate);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.checklist .icons-4 {\n  color: var(--brand-neutral-400);\n  height: 28px !important;\n  position: relative !important;\n  width: 28px !important;\n}\n\n.checklist .icons-5 {\n  color: var(--brand-neutral-400);\n  height: 28px !important;\n  position: relative !important;\n  width: 28px !important;\n}\n\n.checklist .button-6 {\n  align-items: center;\n  background-color: var(--theme-primary-solid-disabledbg-duplicate);\n  border: 1px solid;\n  border-color: #9fa6ad;\n  border-radius: 0px var(--border-radius-radius-sm) var(--border-radius-radius-sm) 0px;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: center;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.checklist .icons-6 {\n  color: var(--brand-neutral-400);\n  height: 28px !important;\n  position: relative !important;\n  width: 28px !important;\n}\n\n.checklist .frame-2 {\n  align-items: flex-end;\n  display: inline-flex;\n  flex: 0 0 auto;\n  justify-content: flex-end;\n  padding: 12px 0px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\n.checklist .frame-3 {\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n\n}\n\n.checklist .loading-overlay{\n  align-self: center;\n  margin: auto 0;\n}\n\n.checklist .name-form {\n  padding: 0px 0px 18px 2px;\n  display: flex;\n  justify-content: space-between; \n  align-items: center;            \n  width: 100%;\n}\n\n.checklist .left-side {\n  display: flex;\n  flex-direction: column; /* stack form above paragraph */\n  gap: 10px;  \n}\n\n.checklist .directions {\n  font-size: 12px;\n  font-family: \"Open Sans variable\", Helvetica;\n  margin: 0; \n}\n\n.checklist .p-bold {\n  font-family: \"Open Sans-Bold\", Helvetica;\n}\n\n.checklist .additional-items{\n  display: flex;\n  min-height: 48px;\n  padding: 6px 24px;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  border-radius: var(--radius-sm, 6px);\n  border: 1px solid var(--14bis-Medium, #16478E);\n}\n\n.checklist .div-wrapper {\n  align-items: center;\n  align-self: stretch;\n  background-color: var(--theme-neutral-solid-color);\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-color: var(--brand-neutral-300);\n  border-left-style: solid;\n  border-left-width: 1px;\n  border-top-style: solid;\n  border-top-width: 1px;\n  display: flex;\n  flex: 0 0 auto;\n  gap: 6px;\n  justify-content: center;\n  padding: 12px;\n  position: relative;\n  width: 100%;\n}\n\n.checklist .text-wrapper-4 {\n  color: var(--theme-text-primary);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 0;\n  line-height: normal;\n  margin-top: -1px;\n  position: relative;\n  width: fit-content;\n}\n\n.checklist .frame-4 {\n  align-items: center;\n  align-self: stretch;\n  background-color: var(--brand-neutral-100);\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-color: var(--brand-neutral-300);\n  border-left-style: solid;\n  border-left-width: 1px;\n  border-top-style: solid;\n  border-top-width: 1px;\n  display: flex;\n  gap: 6px;\n  height: 50px;\n  justify-content: center;\n  padding: 12px;\n  position: relative;\n  width: 100%;\n}\n\n.checklist .text-wrapper-5 {\n  color: var(--theme-text-secondary);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 14px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  width: fit-content;\n}\n\n.checklist .frame-5 {\n  align-items: center;\n  align-self: stretch;\n  background-color: var(--theme-background-surface);\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-color: var(--brand-neutral-300);\n  border-left-style: solid;\n  border-left-width: 1px;\n  border-top-style: solid;\n  border-top-width: 1px;\n  display: flex;\n  gap: 6px;\n  height: 50px;\n  justify-content: center;\n  padding: 12px;\n  position: relative;\n  width: 100%;\n}\n\n.checklist .nomenclature {\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 155px;\n}\n\n.checklist .frame-6 {\n  align-items: center;\n  align-self: stretch;\n  background-color: var(--theme-neutral-solid-color);\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-color: var(--brand-neutral-300);\n  border-top-style: solid;\n  border-top-width: 1px;\n  display: flex;\n  flex: 0 0 auto;\n  gap: 6px;\n  justify-content: center;\n  padding: 12px;\n  position: relative;\n  width: 100%;\n}\n\n.checklist .frame-7 {\n  align-items: center;\n  align-self: stretch;\n  background-color: var(--brand-neutral-100);\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-color: var(--brand-neutral-300);\n  border-top-style: solid;\n  border-top-width: 1px;\n  display: flex;\n  gap: 6px;\n  height: 50px;\n  justify-content: center;\n  padding: 12px;\n  position: relative;\n  width: 100%;\n}\n\n.checklist .frame-8 {\n  align-items: center;\n  align-self: stretch;\n  background-color: var(--theme-background-surface);\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-color: var(--brand-neutral-300);\n  border-top-style: solid;\n  border-top-width: 1px;\n  display: flex;\n  gap: 6px;\n  height: 50px;\n  justify-content: center;\n  padding: 12px;\n  position: relative;\n  width: 100%;\n}\n\n.checklist .frame-9 {\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 131px;\n}\n\n.checklist .frame-wrapper {\n  align-items: center;\n  align-self: stretch;\n  background-color: var(--brand-neutral-100);\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-color: var(--brand-neutral-300);\n  border-top-style: solid;\n  border-top-width: 1px;\n  display: flex;\n  flex: 0 0 auto;\n  gap: 6px;\n  justify-content: center;\n  padding: 12px;\n  position: relative;\n  width: 100%;\n}\n\n.checklist .icons-wrapper {\n  align-items: center;\n  align-self: stretch;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 10px;\n  justify-content: center;\n  padding: 1px 0px;\n  position: relative;\n}\n\n.checklist .icons-7 {\n  position: relative !important;\n}\n\n.checklist .frame-10 {\n  align-items: center;\n  align-self: stretch;\n  background-color: var(--theme-background-surface);\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-color: var(--brand-neutral-300);\n  border-top-style: solid;\n  border-top-width: 1px;\n  display: flex;\n  flex: 0 0 auto;\n  gap: 6px;\n  justify-content: center;\n  padding: 12px;\n  position: relative;\n  width: 100%;\n}\n\n.checklist .frame-11 {\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 146px;\n}\n\n.checklist .frame-12 {\n  align-items: center;\n  background-color: var(--theme-neutral-solid-color);\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-color: var(--brand-neutral-300);\n  border-top-style: solid;\n  border-top-width: 1px;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 6px;\n  justify-content: center;\n  padding: 12px;\n  position: relative;\n}\n\n.checklist .frame-13 {\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 64px;\n}\n\n.checklist .frame-14 {\n  align-items: center;\n  align-self: stretch;\n  background-color: #ffffff;\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-color: var(--brand-neutral-300);\n  border-right-style: solid;\n  border-right-width: 1px;\n  border-top-style: solid;\n  border-top-width: 1px;\n  display: flex;\n  gap: 6px;\n  height: 46px;\n  justify-content: center;\n  padding: 12px;\n  position: relative;\n  width: 100%;\n}\n\n.checklist .frame-15 {\n  align-items: center;\n  align-self: stretch;\n  background-color: var(--brand-neutral-100);\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-color: var(--brand-neutral-300);\n  border-right-style: solid;\n  border-right-width: 1px;\n  border-top-style: solid;\n  border-top-width: 1px;\n  display: flex;\n  gap: 6px;\n  height: 50px;\n  justify-content: center;\n  padding: 12px;\n  position: relative;\n  width: 100%;\n}\n\n.checklist .button-wrapper {\n  align-items: center;\n  align-self: stretch;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 10px;\n  justify-content: center;\n  margin-left: -4px;\n  margin-right: -4px;\n  padding: 1px 0px;\n  position: relative;\n}\n\n.checklist .button-7 {\n  border-radius: var(--border-radius-radius-sm) !important;\n  flex: 0 0 auto !important;\n  margin-bottom: -12px !important;\n  margin-top: -12px !important;\n}\n\n.checklist .icons-8 {\n  height: 20px !important;\n  position: relative !important;\n  width: 20px !important;\n}\n\n.checklist .frame-16 {\n  align-items: center;\n  align-self: stretch;\n  background-color: var(--theme-background-surface);\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-color: var(--brand-neutral-300);\n  border-right-style: solid;\n  border-right-width: 1px;\n  border-top-style: solid;\n  border-top-width: 1px;\n  display: flex;\n  gap: 6px;\n  height: 50px;\n  justify-content: center;\n  padding: 12px;\n  position: relative;\n  width: 100%;\n}\n\n.checklist .table-header {\n    position: 'sticky';\n    top: '0px';\n}\n\n.checklist .table-header-cell {\n  color: var(--theme-text-primary) !important;\n  font-family: Open Sans variable, Helvetica !important;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 0;\n  line-height: normal;\n  margin-top: -1px;\n  position: relative;\n  width: fit-content;\n}\n\n.checklist .native-browser-scroll {\n  height: 346px !important;\n}\n\n.checklist .button-8 {\n  all: unset;\n  align-items: center;\n  border: 1px solid;\n  border-color: var(--brand-color);\n  border-radius: 6px;\n  box-sizing: border-box;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: flex-end;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.checklist .button-9 {\n  all: unset;\n  box-sizing: border-box;\n  color: var(--brand-color);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.checklist .button-10 {\n  all: unset;\n  align-items: center;\n  background-color: var(--brand-color);\n  border-radius: var(--border-radius-radius-sm-duplicate);\n  box-sizing: border-box;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: flex-end;\n  height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.checklist .button-11 {\n  all: unset;\n  box-sizing: border-box;\n  color: var(--theme-primary-solid-color-duplicate);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.checklist .native-browser-instance {\n  height: 646px !important;\n  left: 1265px !important;\n  position: absolute !important;\n  top: 74px !important;\n}\n\n.packingList {\n  background-color: var(--brand-neutral-100);\n  height: 100vh;\n  position: relative;\n  width: 100%;\n}\n\n.packingList .element-logo {\n  height: 61px;\n  position: relative;\n  width: 150px;\n}\n\n\n.packingList .frame {\n  align-items: center;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 16px;\n  justify-content: flex-end;\n  position: relative;\n}\n\n.packingList .button-instance {\n  flex: 0 0 auto !important;\n}\n\n.packingList .icons-instance {\n  height: 20px !important;\n  position: relative !important;\n  width: 20px !important;\n}\n\n.packingList .home-button {\n  color: var(--brand-14bis-blue-medium);\n  flex: 0 0 auto !important;\n}\n\n.packingList .line-desktop-instance {\n  align-self: stretch !important;\n  flex: 0 0 auto !important;\n  width: 100% !important;\n}\n\n.packingList .design-component-instance-node {\n  background-color: var(--colorbordercard) !important;\n}\n\n.packingList .under-banner {\n  align-items: center;  /* centers horizontally */\n  display: flex;\n  flex-direction: column;\n  padding: 4px 12px;\n  position: absolute;   /* keep if needed for placement */\n  top: 70px;\n  left: 3%;\n  width: 91.8%;\n  height: 88vh;\n}\n\n.packingList .div {\n  background-color: var(--theme-background-surface);\n  border-radius: 6px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding: 10px 12px;\n  width: 100%; \n  box-sizing: border-box;       \n  position: relative; \n  flex: 1;            \n}\n\n.packingList .breadcrumb {\n  align-items: center;\n  align-self: stretch;\n  display: flex;\n  flex: 0 0 auto;\n  gap: 8px;\n  justify-content: center;\n  padding: 8px 0px;\n  position: relative;\n  width: 100%;\n}\n\n.packingList .breadcrumb-2 {\n  align-items: center;\n  background-color: var(--theme-primary-solid-color);\n  border-radius: 6px;\n  box-shadow: inset 0px 2px 2px #00000040;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 4px;\n  justify-content: center;\n  padding: 8px;\n  position: relative;\n}\n\n.packingList .button-2 {\n  align-items: center;\n  background-color: var(--brand-14bis-orange-matte);\n  border-radius: 6px 0px 0px 6px;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: center;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.packingList .button-3 {\n  all: unset;\n  box-sizing: border-box;\n  color: #ffffff;\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.packingList .icons-2 {\n  color: var(--brand-common-white);\n  height: 28px !important;\n  position: relative !important;\n  width: 28px !important;\n}\n\n.packingList .button-4 {\n  align-items: center;\n  background-color: var(--brand-14bis-orange-matte);\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: center;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.packingList .text-wrapper-2 {\n  color: #ffffff;\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.packingList .icons-3 {\n  color: var(--brand-common-white);\n  height: 28px !important;\n  position: relative !important;\n  width: 28px !important;\n}\n\n.packingList .button-5 {\n  align-items: center;\n  border: 1px solid;\n  border-color: var(--brand-14bis-orange-matte);\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: center;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.packingList .text-wrapper-3 {\n  color: var(--brand-14bis-orange-matte);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.packingList .icons-4 {\n  color: var(--brand-14bis-orange-matte);\n  height: 28px !important;\n  position: relative !important;\n  width: 28px !important;\n}\n\n.packingList .button-6 {\n  align-items: center;\n  background-color: var(--theme-primary-solid-disabledbg-duplicate);\n  border: 1px solid;\n  border-color: #9fa6ad;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: center;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.packingList .text-wrapper-4 {\n  color: var(--theme-primary-solid-disabledcolor-duplicate);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.packingList .icons-5 {\n  color: var(--brand-neutral-400);\n  height: 28px !important;\n  position: relative !important;\n  width: 28px !important;\n}\n\n.packingList .button-7 {\n  align-items: center;\n  background-color: var(--theme-primary-solid-disabledbg-duplicate);\n  border: 1px solid;\n  border-color: #9fa6ad;\n  border-radius: 0px var(--border-radius-radius-sm) var(--border-radius-radius-sm) 0px;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: center;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.packingList .icons-6 {\n  color: var(--brand-neutral-400);\n  height: 28px !important;\n  position: relative !important;\n  width: 28px !important;\n}\n\n.packingList .frame-2 {\n  align-items: flex-start;\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n  flex: 0 0 auto;\n  justify-content: flex-end;\n  padding: 12px 0px;\n  position: relative;\n  width: 100%;\n}\n\n.packingList .div-2 {\n  align-items: flex-start;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  flex-grow: 1;\n  position: relative;\n}\n\n.packingList .div-wrapper {\n  align-items: center;\n  align-self: stretch;\n  background-color: var(--theme-neutral-solid-color);\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-color: var(--brand-neutral-300);\n  border-left-style: solid;\n  border-left-width: 1px;\n  border-top-style: solid;\n  border-top-width: 1px;\n  display: flex;\n  flex: 0 0 auto;\n  gap: 6px;\n  justify-content: center;\n  padding: 12px;\n  position: relative;\n  width: 100%;\n}\n\n.packingList .text-wrapper-5 {\n  color: var(--theme-text-primary);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 0;\n  line-height: normal;\n  margin-top: -1px;\n  position: relative;\n  width: fit-content;\n}\n\n.packingList .frame-3 {\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  align-self: stretch;\n  /*border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-color: var(--brand-neutral-300);\n  border-left-style: solid;\n  border-left-width: 1px;\n  border-right-style: solid;\n  border-right-width: 1px;\n  border-top-style: solid;\n  border-top-width: 1px;*/\n  display: flex;\n  justify-content: center;\n  position: relative;\n  width: 100%;\n  height: 100%\n}\n\n.packingList .name-form{\n  padding: 0px 0px 18px 2px;\n  display: flex;\n  justify-content: space-between; \n  align-items: center;            \n  width: 100%;\n\n}\n\n.packingList .left-side {\n  display: flex;\n  flex-direction: column; /* stack form above paragraph */\n  gap: 10px;  \n}\n\n.packingList .directions {\n  font-size: 12px;\n  font-family: \"Open Sans variable\", Helvetica;\n  margin: 0; \n}\n\n.packingList .p-bold {\n  font-family: \"Open Sans-Bold\", Helvetica;\n}\n\n.packingList .text-wrapper-6 {\n  color: var(--theme-text-secondary);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 14px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  width: fit-content;\n}\n\n.packingList .frame-4 {\n  align-items: center;\n  align-self: stretch;\n  background-color: var(--theme-neutral-solid-color);\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-color: var(--brand-neutral-300);\n  border-top-style: solid;\n  border-top-width: 1px;\n  display: flex;\n  flex: 0 0 auto;\n  gap: 6px;\n  justify-content: center;\n  padding: 12px;\n  position: relative;\n  width: 100%;\n}\n\n.packingList .frame-5 {\n  align-items: center;\n  align-self: stretch;\n  background-color: var(--brand-neutral-100);\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-color: var(--brand-neutral-300);\n  border-top-style: solid;\n  border-top-width: 1px;\n  display: flex;\n  gap: 6px;\n  height: 50px;\n  justify-content: center;\n  padding: 12px;\n  position: relative;\n  width: 100%;\n}\n\n.packingList .frame-6 {\n  align-items: center;\n  align-self: stretch;\n  background-color: var(--theme-neutral-solid-color);\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-color: var(--brand-neutral-300);\n  border-right-style: solid;\n  border-right-width: 1px;\n  border-top-style: solid;\n  border-top-width: 1px;\n  display: flex;\n  flex: 0 0 auto;\n  gap: 6px;\n  justify-content: center;\n  padding: 12px;\n  position: relative;\n  width: 100%;\n}\n\n.packingList .frame-7 {\n  align-items: center;\n  align-self: stretch;\n  background-color: var(--brand-neutral-100);\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-color: var(--brand-neutral-300);\n  border-right-style: solid;\n  border-right-width: 1px;\n  border-top-style: solid;\n  border-top-width: 1px;\n  display: flex;\n  gap: 6px;\n  height: 50px;\n  justify-content: center;\n  padding: 12px;\n  position: relative;\n  width: 100%;\n}\n\n.packingList .button-wrapper {\n  all: unset;\n  align-items: center;\n  border: 1px solid;\n  border-color: var(--brand-color);\n  border-radius: 6px;\n  box-sizing: border-box;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: flex-end;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.packingList .button-8 {\n  all: unset;\n  align-items: center;\n  border: 1px solid;\n  border-color: var(--brand-color);\n  border-radius: 6px;\n  box-sizing: border-box;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: flex-end;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.packingList .button-9 {\n  all: unset;\n  box-sizing: border-box;\n  color: var(--brand-color);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.packingList .button-10 {\n  all: unset;\n  align-items: center;\n  background-color: var(--brand-color);\n  border-radius: var(--border-radius-radius-sm-duplicate);\n  box-sizing: border-box;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: flex-end;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.packingList .button-11 {\n  all: unset;\n  box-sizing: border-box;\n  color: var(--theme-primary-solid-color-duplicate);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.containerOverview {\n  background-color: var(--brand-neutral-100);\n  height: 100vh;\n  position: relative;\n  width: 100%;\n}\n\n.containerOverview .element-logo {\n  height: 61px;\n  position: relative;\n  width: 150px;\n}\n\n.containerOverview .frame {\n  align-items: center;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 16px;\n  justify-content: flex-end;\n  position: relative;\n}\n\n.containerOverview .button-instance {\n  flex: 0 0 auto !important;\n}\n\n.containerOverview .icons-instance {\n  height: 20px !important;\n  position: relative !important;\n  width: 20px !important;\n}\n\n.containerOverview .home-button {\n  color: var(--brand-14bis-blue-medium);\n  flex: 0 0 auto !important;\n}\n\n.containerOverview .download-btn {\n  height: 28px;\n  width: 28px;\n  transform: translateY(10px);\n  color: var(--brand-14bis-blue-medium);\n}\n\n.containerOverview .line-desktop-instance {\n  align-self: stretch !important;\n  flex: 0 0 auto !important;\n  width: 100% !important;\n}\n\n.containerOverview .design-component-instance-node {\n  background-color: var(--colorbordercard) !important;\n}\n\n.containerOverview .under-banner {\n  align-items: center;  /* centers horizontally */\n  display: flex;\n  flex-direction: column;\n  padding: 4px 12px;\n  position: absolute;   /* keep if needed for placement */\n  top: 70px;\n  left: 3%;\n  width: 91.8%;\n  height: 88vh;\n}\n\n.containerOverview .div {\n  position: absolute;\n  width: 91.8%;\n  background-color: var(--theme-background-surface);\n  border-radius: 6px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding: 10px 12px;\n  padding-bottom: 80px;\n  width: 100%; \n  box-sizing: border-box;       \n  position: relative; \n  flex: 1;            \n}\n\n.containerOverview .breadcrumb {\n  align-items: center;\n  align-self: stretch;\n  display: flex;\n  flex: 0 0 auto;\n  gap: 8px;\n  justify-content: center;\n  padding: 8px 0px;\n  position: relative;\n  width: 100%;\n}\n\n.containerOverview .breadcrumb-2 {\n  align-items: center;\n  background-color: var(--theme-primary-solid-color);\n  border-radius: 6px;\n  box-shadow: inset 0px 2px 2px #00000040;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 4px;\n  justify-content: center;\n  padding: 8px;\n  position: relative;\n}\n\n.containerOverview .button-2 {\n  align-items: center;\n  background-color: var(--brand-14bis-orange-matte);\n  border-radius: 6px 0px 0px 6px;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: center;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.containerOverview .button-3 {\n  all: unset;\n  box-sizing: border-box;\n  color: #ffffff;\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.containerOverview .icons-2 {\n  color: var(--brand-common-white);\n  height: 28px !important;\n  position: relative !important;\n  width: 28px !important;\n}\n\n.containerOverview .button-4 {\n  align-items: center;\n  background-color: var(--brand-14bis-orange-matte);\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: center;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.containerOverview .text-wrapper-2 {\n  color: #ffffff;\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.containerOverview .icons-3 {\n  color: var(--brand-common-white);\n  height: 28px !important;\n  position: relative !important;\n  width: 28px !important;\n}\n\n.containerOverview .button-4 {\n  align-items: center;\n  background-color: var(--brand-14bis-orange-matte);\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: center;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.containerOverview .text-wrapper-2 {\n  color: #ffffff;\n  font-family: Open Sans-SemiBold variable, Helvetica;\n;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.containerOverview .button-5 {\n  align-items: center;\n  border: 1px solid;\n  border-color: var(--brand-14bis-orange-matte);\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: center;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.containerOverview .text-wrapper-3 {\n  color: var(--brand-14bis-orange-matte);\n  font-family: Open Sans-SemiBold variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.containerOverview .icons-4 {\n  color: var(--brand-14bis-orange-matte);\n  height: 28px !important;\n  position: relative !important;\n  width: 28px !important;\n}\n\n.containerOverview .button-6 {\n  align-items: center;\n  background-color: var(--theme-primary-solid-disabledbg-duplicate);\n  border: 1px solid;\n  border-color: #9fa6ad;\n  border-radius: 0px var(--border-radius-radius-sm) var(--border-radius-radius-sm) 0px;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: center;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.containerOverview .text-wrapper-4 {\n  color: var(--theme-primary-solid-disabledcolor-duplicate);\n  font-family: Open Sans-SemiBold variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.containerOverview .icons-5 {\n  color: var(--brand-neutral-400);\n  height: 28px !important;\n  position: relative !important;\n  width: 28px !important;\n}\n\n.containerOverview .frame-2 {\n  align-items: self-start;\n  background-color: var(--theme-background-surface);\n  border-radius: 6px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\n.containerOverview .name-form {\n  padding: 0px 0px 0px 8px;\n  display: flex;\n  justify-content: space-between; \n  align-items: center;            \n  width: 100%;\n  box-sizing: border-box;\n}\n\n.containerOverview .left-side {\n  display: flex;\n  flex-direction: column; /* stack form above paragraph */\n  gap: 10px;  \n}\n\n.containerOverview .header-row{\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start; \n  gap: 8px;\n}\n\n/* Ensure the form doesn't take up 100% width if it's a block element */\n.containerOverview .header-row > form {\n  display: inline-block;\n}\n.containerOverview .directions {\n  font-size: 12px;\n  font-family: \"Open Sans variable\", Helvetica;\n  margin: 0; \n}\n\n.containerOverview .p-bold {\n  font-family: \"Open Sans-Bold\", Helvetica;\n}\n\n.containerOverview .div-2 {\n  align-items: flex-start;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  flex-grow: 1;\n  position: relative;\n}\n\n.containerOverview .container {\n  align-items: center;\n  display: inline-flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  gap: 8px;\n  position: relative;\n}\n\n\n.containerOverview .tab-2 {\n  align-items: center;\n  background-color: var(--theme-background-surface);\n  border: 1px solid;\n  border-color: #cdd7e1;\n  border-radius: 6px 6px 0px 0px;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 8px;\n  padding: 8px 20px;\n  position: relative;\n}\n\n.containerOverview .tab-3 {\n  align-items: center;\n  background-color: var(--theme-background-surface);\n  border: 1px solid;\n  border-color: #cdd7e1;\n  border-radius: 6px 6px var(--border-radius-radius-none) var(--border-radius-radius-none);\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 8px;\n  padding: 8px 20px;\n  position: relative;\n}\n\n.containerOverview .divisor {\n  height: 1px;\n  object-fit: cover;\n  position: relative;\n  width: 1126px;\n}\n\n.containerOverview .table-2 {\n  align-items: flex-end;\n  display: flex;\n  height: 406px;\n  position: relative;\n  width: 1140px;\n}\n\n.containerOverview .nomenclature {\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 189px;\n}\n\n.containerOverview .div-wrapper {\n  align-items: center;\n  align-self: stretch;\n  background-color: var(--theme-neutral-solid-color);\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-color: var(--brand-neutral-300);\n  border-left-style: solid;\n  border-left-width: 1px;\n  display: flex;\n  gap: 6px;\n  height: 56px;\n  justify-content: center;\n  padding: 12px;\n  position: relative;\n  width: 100%;\n}\n\n.containerOverview .frame-3 {\n  align-items: start;\n  align-self: stretch;\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-color: var(--brand-neutral-300);\n  border-left-width: 1px;\n  border-top-width: 1px;\n  gap: 6px;\n  justify-content: center;\n  position: relative;\n  width: 100%;\n}\n\n.containerOverview .positioning-order {\n  color: var(--theme-text-primary);\n  font-family: Open Sans-Bold variable, Helvetica;\n\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 0;\n  line-height: 16px;\n  margin-top: -1px;\n  position: relative;\n  text-align: center;\n  width: 102px;\n}\n\n.containerOverview .frame-11 {\n  align-items: flex-start;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  flex-grow: 1;\n  position: relative;\n}\n\n.containerOverview .placement-direction {\n  color: var(--theme-text-primary);\n  font-family: Open Sans-Bold variable, Helvetica;\n\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 0;\n  line-height: 16px;\n  margin-top: -1px;\n  position: relative;\n  text-align: center;\n  width: fit-content;\n}\n\n.containerOverview .vertical-instance {\n  margin-bottom: -8px !important;\n  margin-top: -8px !important;\n  position: relative !important;\n}\n\n.containerOverview .frame-12 {\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 154px;\n}\n\n.containerOverview .button-wrapper {\n  all: unset;\n  align-items: center;\n  border: 1px solid;\n  border-color: var(--brand-color);\n  border-radius: 6px;\n  box-sizing: border-box;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: flex-end;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.containerOverview .button-7 {\n  all: unset;\n  box-sizing: border-box;\n  color: var(--brand-color);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.containerOverview .button-8 {\n    all: unset;\n  align-items: center;\n  background-color: var(--brand-color);\n  border-radius: var(--border-radius-radius-sm-duplicate);\n  box-sizing: border-box;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: flex-end;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.containerOverview .button-9 {\n  all: unset;\n  box-sizing: border-box;\n  color: var(--theme-primary-solid-color-duplicate);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.containerOverview .native-browser-instance {\n  height: 646px !important;\n  left: 1265px !important;\n  position: absolute !important;\n  top: 74px !important;\n}\n\n.finalpacking {\n  background-color: var(--brand-neutral-100);\n  height: 100vh;\n  position: relative;\n  width: 100%;\n}\n\n.finalpacking .element-logo {\n  height: 61px;\n  position: relative;\n  width: 150px;\n}\n\n.finalpacking .frame {\n  align-items: center;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 16px;\n  justify-content: flex-end;\n  position: relative;\n}\n\n.finalpacking .button-instance {\n  flex: 0 0 auto !important;\n}\n\n.finalpacking .icons-instance {\n  height: 20px !important;\n  position: relative !important;\n  width: 20px !important;\n}\n\n.finalpacking .home-button {\n  color: var(--brand-14bis-blue-medium);\n  flex: 0 0 auto !important;\n}\n\n.finalpacking .expand-button {\n  color: var(--brand-14bis-blue-medium);\n  flex: 0 0 auto !important;\n}\n\n.finalpacking .line-desktop-instance {\n  align-self: stretch !important;\n  flex: 0 0 auto !important;\n  width: 100% !important;\n}\n\n.finalpacking .design-component-instance-node {\n  flex: 0 0 auto !important;\n}\n\n.finalpacking .line-desktop-2 {\n  align-self: stretch !important;\n  flex: 0 0 auto !important;\n  width: 100% !important;\n}\n\n.finalpacking .line-desktop-3 {\n  background-color: var(--colorbordercard) !important;\n}\n\n.finalpacking .under-banner-expand {\n  position: absolute;\n  top: 70px;\n  padding: 4px 12px;\n  width: 91.8%;\n  height: 100%;\n}\n\n.finalpacking .div {\n  background-color: var(--theme-background-surface);\n  border-radius: 6px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding: 10px 12px;\n  padding-bottom: 92px;\n  width: 100%; \n  box-sizing: border-box;       \n  position: relative; \n  flex: 1;            \n}\n.finalpacking .under-banner{\n  align-items: center;  /* centers horizontally */\n  display: flex;\n  flex-direction: column;\n  padding: 4px 12px;\n  position: absolute;   /* keep if needed for placement */\n  top: 70px;\n  left: 3%;\n  width: 91.8%;\n  height: 88vh;\n}\n\n.finalpacking .overlap-group-wrapper {\n  height: 591px;\n  left: 52px;\n  top: 98px;\n}\n\n.finalpacking .overlap-group {\n  height: 591px;\n  position: relative;\n}\n\n.finalpacking .frame-wrapper {\n  height: 591px;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n\n.finalpacking .frame-2 {\n  background-color: var(--theme-background-surface); \n  border-radius: 6px;\n  display: flex;\n  flex-direction: column;\n  height: 95%;\n  overflow: hidden;\n  padding: 10px 12px;\n  position: absolute;\n  width: 95%;\n  gap: 10px;\n}\n\n.finalpacking .frame-2-expand {\n  justify-content: space-between;\n  background-color: var(--theme-background-surface); \n  border-radius: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  height: calc(100vh - 90px);\n  overflow: hidden;\n  padding: 10px 12px;\n  position: absolute;\n  width: 100%;\n  box-sizing: border-box;\n  align-items: center; \n}\n\n.finalpacking .breadcrumb {\n  align-items: center;\n  align-self: stretch;\n  display: flex;\n  flex: 0 0 auto;\n  gap: 6px;\n  justify-content: center;\n  padding: 6px 0px;\n  position: relative;\n  width: 100%;\n}\n\n.finalpacking .breadcrumb-2 {\n  align-items: center;\n  background-color: var(--theme-primary-solid-color);\n  border-radius: 6px;\n  box-shadow: inset 0px 2px 2px #00000040;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 4px;\n  justify-content: center;\n  padding: 8px;\n  position: relative;\n}\n.finalpacking .in-line{\n  display: flex;\n  height: 55vh;\n  gap:12px;\n  justify-content: space-between;\n}\n\n.finalpacking .button-2 {\n  align-items: center;\n  background-color: var(--brand-14bis-orange-matte);\n  border-radius: 6px 0px 0px 6px;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: center;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.finalpacking .button-3 {\n  all: unset;\n  box-sizing: border-box;\n  color: #ffffff;\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.finalpacking .icons-2 {\n  color: var(--brand-common-white);\n  height: 28px !important;\n  position: relative !important;\n  width: 28px !important;\n}\n\n.finalpacking .button-4 {\n  align-items: center;\n  background-color: var(--brand-14bis-orange-matte);\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: center;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.finalpacking .text-wrapper-2 {\n  color: #ffffff;\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.finalpacking .button-5 {\n  align-items: center;\n  border: 1px solid;\n  border-color: var(--brand-14bis-orange-matte);\n  border-radius: 0px 6px 6px 0px;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: center;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.finalpacking .text-wrapper-3 {\n  color: var(--brand-14bis-orange-matte);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.finalpacking .icons-3 {\n  color: var(--brand-14bis-orange-matte);\n  height: 28px !important;\n  position: relative !important;\n  width: 28px !important;\n}\n\n.finalpacking .element-table {\n  align-items: center;\n  display: inline-flex;\n  gap: 24px;\n  height: 406px;\n  justify-content: space-between;\n  position: relative;\n}\n\n.finalpacking .table {\n  align-items: flex-start;\n  align-self: flex-start;\n  flex-direction: column;\n  position: relative;\n  width: 690px;\n  height:200px;\n}\n\n.finalpacking .name-form {\n  padding: 0px 0px 0px 8px;\n  display: flex;\n  justify-content: space-between; \n  align-items: center;            \n  width: 100%;\n  box-sizing: border-box;\n}\n\n.finalpacking .left-side {\n  display: flex;\n  flex-direction: column; /* stack form above paragraph */\n  gap: 10px;  \n}\n\n.finalpacking .right-side {\n  display: inline-flex;\n  gap: 12px;  \n}\n\n.finalpacking .directions {\n  font-size: 12px;\n  font-family: \"Open Sans variable\", Helvetica;\n  margin: 0; \n}\n\n.finalpacking .p-bold {\n  font-family: \"Open Sans-Bold\", Helvetica;\n}\n\n.finalpacking .tabs {\n  align-items: flex-start;\n  align-self: stretch;\n  border: 0px none;\n  border-color: var(--theme-neutral-outlined-border);\n  display: flex;\n  flex: 0 0 auto;\n  position: relative;\n  width: 100%;\n}\n\n.finalpacking .tab {\n  align-items: center;\n  background-color: var(--theme-primary-outlined-hoverbg);\n  border: 1px solid;\n  border-color: var(--brand-14bis-blue-medium);\n  border-radius: 6px 6px var(--border-radius-radius-none) var(--border-radius-radius-none);\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 8px;\n  padding: 8px 20px;\n  position: relative;\n}\n\n.finalpacking .container {\n  align-items: center;\n  display: inline-flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  gap: 8px;\n  position: relative;\n}\n\n.finalpacking .text-wrapper-4 {\n  color: var(--brand-14bis-blue-medium);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 18px;\n  font-weight: 700;\n  letter-spacing: 0;\n  line-height: 27.9px;\n  margin-top: -1px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.finalpacking .tab-2 {\n  align-items: center;\n  background-color: var(--theme-background-surface);\n  border: 1px solid;\n  border-color: #cdd7e1;\n  border-radius: 6px 6px 0px 0px;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 8px;\n  padding: 8px 20px;\n  position: relative;\n}\n\n.finalpacking .text-wrapper-5 {\n  color: var(--theme-text-icon);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 18px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 27.9px;\n  margin-top: -1px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.finalpacking .tab-3 {\n  align-items: center;\n  background-color: var(--theme-background-surface);\n  border: 1px solid;\n  border-color: #cdd7e1;\n  border-radius: 6px 6px var(--border-radius-radius-none) var(--border-radius-radius-none);\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 8px;\n  padding: 8px 20px;\n  position: relative;\n}\n\n.finalpacking .line {\n  height: 1px;\n  object-fit: cover;\n  position: relative;\n  width: 676px;\n}\n\n.finalpacking .table-2 {\n  align-items: flex-start;\n  align-self: stretch;\n  display: flex;\n  flex: 0 0 auto;\n  position: relative;\n  width: 100%;\n}\n\n.finalpacking .frame-3 {\n  align-items: flex-start;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  flex-grow: 1;\n  position: relative;\n}\n\n.finalpacking .frame-4 {\n  align-items: center;\n  align-self: stretch;\n  background-color: #f5f5f5;\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-color: var(--brand-neutral-300);\n  border-left-style: solid;\n  border-left-width: 1px;\n  display: flex;\n  flex: 0 0 auto;\n  justify-content: space-between;\n  padding: 6px 24px;\n  position: relative;\n  width: 100%;\n}\n\n.finalpacking .text-wrapper-6 {\n  color: var(--brand-14bis-blue-medium);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  width: fit-content;\n}\n\n.finalpacking .icon-wrapper {\n  align-items: center;\n  border-radius: 6px;\n  display: inline-flex;\n  flex: 0 0 auto;\n  justify-content: center;\n  min-height: 48px;\n  min-width: 48px;\n  position: relative;\n}\n\n.finalpacking .div-wrapper {\n  align-items: flex-start;\n  display: inline-flex;\n  flex: 0 0 auto;\n  position: relative;\n}\n\n.finalpacking .chevron-left-wrapper {\n  height: 20px;\n  position: relative;\n  width: 20px;\n}\n\n.finalpacking .chevron-left {\n  height: 20px !important;\n  left: 0 !important;\n  position: absolute !important;\n  top: 0 !important;\n  transform: rotate(-90deg) !important;\n  width: 20px !important;\n}\n\n.finalpacking .frame-5 {\n  align-items: center;\n  align-self: stretch;\n  background-color: #f5f5f5;\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-color: var(--brand-neutral-300);\n  border-left-style: solid;\n  border-left-width: 1px;\n  border-top-style: solid;\n  border-top-width: 1px;\n  display: flex;\n  flex: 0 0 auto;\n  justify-content: space-between;\n  padding: 6px 24px;\n  position: relative;\n  width: 100%;\n}\n\n.finalpacking .frame-6 {\n  align-items: center;\n  align-self: stretch;\n  background-color: var(--theme-primary-outlined-hoverbg);\n  border: 1px solid;\n  border-color: var(--brand-14bis-blue-light);\n  display: flex;\n  height: 62px;\n  justify-content: space-between;\n  padding: 6px 24px;\n  position: relative;\n  width: 100%;\n}\n\n.finalpacking .text-wrapper-7 {\n  color: var(--brand-14bis-blue-dark);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  width: fit-content;\n}\n\n.finalpacking .native-browser-scroll {\n  align-self: stretch !important;\n  height: unset !important;\n}\n\n.finalpacking .frame-7 {\n  margin-left: auto;\n  align-items: flex-end;\n  flex: 1 1 auto;\n  position: relative;\n  width: 300px;\n  height: 100%;\n}\n\n.finalpacking .expanded-box {\n  align-items: stretch;\n  display: flex;\n  flex: 1 1 auto;\n  position: relative;\n  box-sizing: border-box;\n  height: calc(100vh - 100px);\n\n\n}\n\n.finalpacking .controller-carousel {\n  align-items: center;\n  display: inline-flex;\n  flex-direction: column;\n  height: 67px;\n  justify-content: space-around;\n  position: relative;\n}\n\n.finalpacking .direction-container {\n  align-items: flex-start;\n  align-self: stretch;\n  display: flex;\n  flex: 0 0 auto;\n  justify-content: space-between;\n  position: relative;\n  width: 100%;\n}\n\n.finalpacking .image {\n  height: 300px;\n  position: relative;\n  width: 300px;\n}\n\n.finalpacking .chip-outlined {\n  align-items: center;\n  background-color: #ffffff;\n  border: 0.53px solid;\n  border-color: var(--theme-neutral-outlined-border);\n  border-radius: 12.76px;\n  display: inline-flex;\n  gap: 3.19px;\n  left: 13px;\n  min-height: 14.89px;\n  padding: 0px 6.38px;\n  position: absolute;\n  top: 83px;\n}\n\n.finalpacking .p {\n  color: var(--theme-neutral-outlined-color);\n  font-family: var(--typography-md-500-1-5-font-family);\n  font-size: var(--typography-md-500-1-5-font-size);\n  font-style: var(--typography-md-500-1-5-font-style);\n  font-weight: var(--typography-md-500-1-5-font-weight);\n  letter-spacing: var(--typography-md-500-1-5-letter-spacing);\n  line-height: var(--typography-md-500-1-5-line-height);\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.finalpacking .span {\n  font-family: var(--typography-md-500-1-5-font-family);\n  font-size: var(--typography-md-500-1-5-font-size);\n  font-style: var(--typography-md-500-1-5-font-style);\n  font-weight: var(--typography-md-500-1-5-font-weight);\n  letter-spacing: var(--typography-md-500-1-5-letter-spacing);\n  line-height: var(--typography-md-500-1-5-line-height);\n}\n\n.finalpacking .text-wrapper-8 {\n  color: #171a1c;\n  font-family: Open Sans variable, Helvetica;\n  font-size: 10px;\n  font-weight: 600;\n  left: 74px;\n  letter-spacing: 0;\n  line-height: 15px;\n  position: absolute;\n  top: 108px;\n  white-space: nowrap;\n}\n\n.finalpacking .text-wrapper-9 {\n  color: var(--theme-text-secondary);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 10px;\n  font-weight: 400;\n  left: 954px;\n  letter-spacing: 0;\n  line-height: 15px;\n  position: absolute;\n  top: 452px;\n  white-space: nowrap;\n}\n\n.finalpacking .text-wrapper-10 {\n  color: var(--theme-text-secondary);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 10px;\n  font-weight: 400;\n  left: 866px;\n  letter-spacing: 0;\n  line-height: 15px;\n  position: absolute;\n  top: 452px;\n  white-space: nowrap;\n}\n\n.finalpacking .text-wrapper-11 {\n  color: var(--theme-text-secondary);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 10px;\n  font-weight: 400;\n  left: 957px;\n  letter-spacing: 0;\n  line-height: 15px;\n  position: absolute;\n  top: 231px;\n  white-space: nowrap;\n}\n\n.finalpacking .button-wrapper {\n  all: unset;\n  align-items: center;\n  border: 1px solid;\n  border-color: var(--brand-color);\n  border-radius: 6px;\n  box-sizing: border-box;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: flex-end;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.finalpacking .button-6 {\n  all: unset;\n  box-sizing: border-box;\n  color: var(--brand-color);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.finalpacking .button-7 {\n  all: unset;\n  align-items: center;\n  background-color: var(--brand-color);\n  border-radius: var(--border-radius-radius-sm-duplicate);\n  box-sizing: border-box;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 12px;\n  justify-content: flex-end;\n  min-height: 48px;\n  padding: 6px 24px;\n  position: relative;\n}\n\n.finalpacking .button-8 {\n  all: unset;\n  box-sizing: border-box;\n  color: var(--theme-primary-solid-color-duplicate);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 16px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.finalpacking .native-browser-instance {\n  height: 646px !important;\n  left: 1265px !important;\n  position: absolute !important;\n  top: 74px !important;\n}\n.finalpacking .check-table{\n  align-items: center;\n  align-self: stretch;\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  gap: 24px;\n  position: relative;\n  width: 100%;\n}\n.finalpacking .checkmark {\n  position: relative !important;\n  width: 168px !important;\n  overflow-y: hidden;\n}\n.finalpacking .bold-discription{\n  align-self: stretch;\n  color: var(--theme-text-primary);\n  font-family: Open Sans-Bold variable, Helvetica;\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: 0;\n  line-height: 30px;\n  position: relative;\n  text-align: center;\n}\n.finalpacking .discription{\n  color: var(--text-secondary, #32383E);\n  text-align: center;\n  font-feature-settings: 'clig' off, 'liga' off;\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n.finalpacking .div-3 {\n  align-items: center;\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  gap: 12px;\n  position: relative;\n  width: 597px;\n}\n\n\n.finalpacking .shelf-button-border {\n    border: 1px solid #16478e; /* Increased border thickness (from 1px to 2px) */\n    border-radius: 8px;\n    \n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    \n    background: var(--theme-background-surface);\n    position: relative;\n    cursor: pointer;\n\n    /* Increased padding creates more space around the icon */\n    padding: 16px; \n    \n    /* Retain original icon font-size */\n    font-size: 28px;\n}\n\n.finalpacking .shelf-button-border path {\n    fill: #16478e;\n}\n.finalpacking .shelf-button-border svg {\n    width: 28px;\n    height: 28px;\n    flex-shrink: 0;\n}\n\n.finalpacking .icon-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.finalpacking .shelf-icon {\n  font-size: 28px;\n  padding: 6px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--brand-14bis-blue-medium);\n}\n\n\n.printout {\n  align-items: center;\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  height: 980px;\n  /*height: 842px;*/\n  padding: 0px 12px;\n  position: relative;\n  width: 695px;\n}\n\n.printout .page{\n  align-items: center;\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  height: 842px;\n  padding: 0px 12px;\n  position: relative;\n  width: 595px;\n}\n\n.printout .frame {\n  align-items: flex-start;\n  align-self: stretch;\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  gap: 6px;\n  justify-content: center;\n  padding: 6px 12px;\n  position: relative;\n  width: 100%;\n}\n\n.printout .frame-2 {\n  align-items: center;\n  align-self: stretch;\n  display: flex;\n  flex: 0 0 auto;\n  justify-content: space-between;\n  padding: 0px 0px;\n  position: relative;\n  width: 100%;\n}\n\n.printout .headline-copy {\n  color: var(--theme-text-primary);\n  font-family: \"Open Sans-SemiBold\", Helvetica;\n  font-size: 16px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 30px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.printout .text-wrapper {\n  color: #171a1c;\n  font-weight: 600;\n}\n\n.printout .span {\n  color: #31383e;\n  font-family: Open Sans variable, Helvetica;\n}\n\n.printout .logo-vertical-instance {\n  height: 40px !important;\n  position: relative !important;\n  width: 83px !important;\n}\n\n.printout .element-find-the-boxes-for {\n  align-self: stretch;\n  color: var(--theme-text-secondary);\n  font-family: Open Sans variable, Helvetica;  font-size: 12px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 12px;\n  position: relative;\n}\n\n.printout .divider-horizontal-instance {\n  align-self: stretch !important;\n  flex: 0 0 auto !important;\n  width: 100% !important;\n}\n\n.printout .frame-3 {\n  align-items: flex-start;\n  display: flex;\n  flex: 0 0 auto;\n  justify-content: space-between;\n  position: relative;\n  width: 545.4px;\n}\n\n.printout .div-2 {\n  align-items: center;\n  display: inline-flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  gap: 16px;\n  position: relative;\n}\n\n.printout .text-wrapper-2 {\n  color: var(--theme-neutral-outlined-color);\n  font-family: Open Sans variable, Helvetica;  font-size: 12px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 18px;\n  margin-top: -1px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n \n\n.printout .overlap-group-wrapper {\n  height: 130.97px;\n  position: relative;\n  width: 127.03px;\n}\n\n.printout .overlap-group-2 {\n  background-size: 100% 100%;\n  height: 136px;\n  left: 5px;\n  position: relative;\n  top: -5px;\n  width: 123px;\n}\n\n.printout .text-wrapper-3 {\n  color: var(--theme-text-secondary);\n  font-family: Open Sans variable, Helvetica;  font-size: 4.2px;\n  font-weight: 400;\n  left: 24px;\n  letter-spacing: 0;\n  line-height: 6.4px;\n  position: absolute;\n  top: 122px;\n  white-space: nowrap;\n}\n\n.printout .text-wrapper-4 {\n  color: var(--theme-text-secondary);\n  font-family: Open Sans variable, Helvetica;  font-size: 4.2px;\n  font-weight: 400;\n  left: 77px;\n  letter-spacing: 0;\n  line-height: 6.4px;\n  position: absolute;\n  top: 121px;\n  white-space: nowrap;\n}\n\n.printout .text-wrapper-5 {\n  color: var(--theme-text-secondary);\n  font-family: Open Sans variable, Helvetica;  font-size: 4.2px;\n  font-weight: 400;\n  left: 75px;\n  letter-spacing: 0;\n  line-height: 6.4px;\n  position: absolute;\n  top: 4px;\n  white-space: nowrap;\n}\n\n.printout .text-wrapper-6 {\n  color: var(--theme-text-secondary);\n  font-family: Open Sans variable, Helvetica;  font-size: 4.2px;\n  font-weight: 400;\n  left: 24px;\n  letter-spacing: 0;\n  line-height: 6.4px;\n  position: absolute;\n  top: 5px;\n  white-space: nowrap;\n}\n\n.printout .frame-4 {\n  align-items: flex-start;\n  display: flex;\n  flex: 0 0 auto;\n  gap: 7.94px;\n  justify-content: center;\n  position: relative;\n  width: 378px;\n}\n\n.printout .boxes-level {\n  align-self: stretch;\n  flex: 1;\n  flex-grow: 1;\n  position: relative;\n}\n\n.printout .img {\n  flex: 1;\n  flex-grow: 1;\n  height: 129.06px;\n  position: relative;\n}\n\n.printout .boxes-level-2 {\n  flex: 1;\n  flex-grow: 1;\n  height: 129.06px;\n  object-fit: cover;\n  position: relative;\n}\n\n.printout .ISU-quadrant {\n  color: var(--theme-neutral-outlined-color);\n  font-family: Open Sans variable, Helvetica;  font-size: 12px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 9px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n  height: 9px;\n}\n\n.printout .frame-5 {\n  align-items: flex-start;\n  display: inline-flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  gap: 32px;\n  position: relative;\n}\n.printout .blank{\n  height:60px;\n  width:100%;\n  clear:both;\n\n}\n\n.printout .frame-6 {\n  align-items: flex-start;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 16px;\n  position: relative;\n}\n\n.printout .print {\n  height: 82.93px;\n  object-fit: cover;\n  position: relative;\n  width: 270px;\n}\n\n.printout .print-2 {\n  height: 82.93px;\n  position: relative;\n  width: 270px;\n}\n\n.printout .print-3 {\n  height: 82.93px;\n  position: relative;\n  width: 178.88px;\n}\n\n.printout .frame-wrapper {\n  align-items: flex-end;\n  align-self: stretch;\n  background-color: #ffffff;\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  position: relative;\n  width: 571px;\n  left: 40px;\n}\n\n.printout .frame-7 {\n  align-items: center;\n  display: flex;\n  flex: 0 0 auto;\n  justify-content: space-between;\n  position: relative;\n  width: 571px;\n}\n\n.printout .frame-8 {\n  align-items: center;\n  align-self: stretch;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 11.28px;\n  position: relative;\n}\n\n.printout .div-wrapper {\n  align-items: center;\n  align-self: stretch;\n  display: flex;\n  gap: 4.84px;\n  justify-content: center;\n  padding: 9.67px;\n  position: relative;\n  width: 24px;\n}\n\n.printout .text-wrapper-7 {\n  color: var(--theme-danger-solid-disabledcolor);\n  font-family: Open Sans variable, Helvetica;  font-size: 11.3px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: normal;\n  margin-bottom: -2.3px;\n  margin-left: -5.67px;\n  margin-right: -5.67px;\n  margin-top: -3.91px;\n  position: relative;\n  width: fit-content;\n}\n\n.printout .this-symbol {\n  color: var(--theme-text-icon);\n  font-family: Open Sans variable, Helvetica;  font-size: 8.1px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  width: 105px;\n}\n\n.printout .text-wrapper-8 {\n  color: #636b74;\n  font-family: Open Sans variable, Helvetica;  font-size: 8.1px;\n  font-weight: 400;\n  letter-spacing: 0;\n}\n\n.printout .text-wrapper-9 {\n  font-family: \"Open Sans-SemiBold\", Helvetica;\n  font-weight: 600;\n}\n\n.printout .frame-9 {\n  align-items: center;\n  align-self: stretch;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 8px;\n  position: relative;\n}\n\n.printout .vertical-instance {\n  height: 28.13px !important;\n  position: relative !important;\n  width: 28.13px !important;\n}\n\n.printout .design-component-instance-node {\n  height: 28px !important;\n  width: 28px !important;\n}\n\n.printout .vertical-2 {\n  height: 16px !important;\n  left: 6px !important;\n  width: 16px !important;\n}\n\n.printout .vertical-3 {\n  height: 16px !important;\n  left: 0 !important;\n  position: absolute !important;\n  top: 0 !important;\n  transform: rotate(-180deg) !important;\n  width: 16px !important;\n}\n\n.printout .vertical-4 {\n  height: 16px !important;\n  top: 6px !important;\n  width: 16px !important;\n}\n\n.printout .vertical-5 {\n  height: 16px !important;\n  left: 0 !important;\n  position: absolute !important;\n  top: 0 !important;\n  transform: rotate(-90deg) !important;\n  width: 16px !important;\n}\n\n.printout .vertical-6 {\n  height: 16px !important;\n  left: 6px !important;\n  top: 12px !important;\n  width: 16px !important;\n}\n\n.printout .vertical-7 {\n  height: 16px !important;\n  left: 12px !important;\n  top: 6px !important;\n  width: 16px !important;\n}\n\n.printout .vertical-8 {\n  background-color: var(--theme-danger-solid-disabledcolor) !important;\n  height: 7px !important;\n  left: 11px !important;\n  top: 11px !important;\n  width: 7px !important;\n}\n\n.printout .p {\n  align-self: stretch;\n  color: var(--theme-text-icon);\n  font-family: Open Sans variable, Helvetica;  font-size: 8.1px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: normal;\n  margin-top: -0.81px;\n  position: relative;\n  width: 108px;\n}\n\n.printout .frame-10 {\n  align-items: center;\n  align-self: stretch;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 14px;\n  opacity: 0.8;\n  padding: 0px 0px 0px 5px;\n  position: relative;\n}\n\n.printout .component {\n  height: 14.18px !important;\n  position: relative !important;\n  width: 16.2px !important;\n}\n\n.printout .this-symbol-2 {\n  color: var(--theme-text-icon);\n  font-family: Open Sans variable, Helvetica;  font-size: 8.1px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n  width: 110px;\n}\n\n.printout .level-canvas {\n  height: 186px;\n  left: 0;\n  object-fit: cover;\n  position: fixed;\n  top: 0;\n  width: 500px;\n}\n\n.printout .top{\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 680px;\n}\n\n.printout .frame-11 {\n  align-items: flex-start;\n  align-self: stretch;\n  display: flex;\n  flex: 0 0 auto;\n  position: relative;\n  width: 100%;\n}\n\n.printout .frame-11-wrapper {\n  align-items: center;\n  background-color: #ffffff;\n  border: 1px solid;\n  border-color: var(--border-radius-borda);\n  display: flex;\n  gap: 10px;\n  height: 30px;\n  padding: 10px;\n  position: relative;\n  width: 680px;\n}\n\n.printout .div-2 {\n  align-items: center;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 10px;\n  margin-bottom: -3px;\n  margin-top: -3px;\n  position: relative;\n}\n\n.printout .div-2-wrapper {\n  align-items: center;\n  display: flex;\n  position: relative;\n  width: 293px;\n}\n\n.printout .text-wrapper-10-1 {\n  color: #000000;\n  font-family: Open Sans variable, Helvetica;  font-size: 12px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: normal;\n  margin-top: -1px;\n  position: relative;\n  width: 466px;\n  \n}\n\n.printout .text-wrapper-10 {\n  color: #000000;\n  font-family: Open Sans variable, Helvetica;  font-size: 12px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: normal;\n  margin-top: -1px;\n  position: relative;\n  width: fit-content;\n}\n\n.printout .frame-12 {\n  align-items: center;\n  display: flex;\n  position: relative;\n  width: 36px;\n}\n\n.printout .frame-13 {\n  align-items: center;\n  display: flex;\n  position: relative;\n  width: 41px;\n}\n\n.printout .frame-14 {\n  align-items: center;\n  display: inline-flex;\n  flex: 0 0 auto;\n  position: relative;\n  width: 41px;\n}\n\n.printout .frame-15 {\n  align-items: center;\n  background-color: #ffffff;\n  border: 1px solid;\n  border-color: var(--border-radius-borda);\n  display: flex;\n  flex: 1;\n  flex-grow: 1;\n  gap: 10px;\n  height: 30px;\n  padding: 10px;\n  position: relative;\n}\n\n.printout .image-ref {\n  align-items: center;\n  display: flex;\n  gap: 10px;\n  margin-bottom: -3px;\n  margin-left: 5.15px;\n  margin-top: -3px;\n  position: relative;\n  width: 174px;\n}\n.printout .frame-16 {\n  align-items: center;\n  display: flex;\n  margin-bottom: -3px;\n  margin-left: 13px;\n  margin-right: -5.15px;\n  margin-top: -3px;\n  position: relative;\n  width: 200px;\n}\n\n.printout .frame-17 {\n  align-items: center;\n  text-align: center;\n  display: flex;\n  position: relative;\n  width: 70px;\n}\n\n.printout .frame-18 {\n  align-items: center;\n  text-align: center;\n  display: flex;\n  position: relative;\n  width: 60px;\n}\n\n.printout .vq-st {\n  align-items: flex-start;\n  display: flex;\n  gap: 2px;\n  position: relative;\n}\n\n.printout .vt-img {\n  height: 310px !important;\n  z-index: 1;\n  position: relative;\n  width: 340px !important;\n}\n.printout .chip{\n  position: absolute; \n  top: 6px;\n}\n.printout .tables {\n  align-items: center;\n  width: 100%;\n}\n.printout .div-3 {\n  align-items: flex-start;\n  display: inline-flex;\n  flex: 0 0 auto;\n  position: absolute;\n}\n\n.printout .div-4 {\n  align-items: flex-start;\n  display: inline-flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  position: relative;\n  width : 230px;\n}\n\n.printout .text-wrapper-3 {\n  color: #000000;\n  font-family: Open Sans-SemiBold variable, Helvetica;\n  font-size: 8px;\n  font-weight: 600;\n  height: 11px;\n  /*left: 60px;*/\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  /*top: 167px;*/\n  left: 196px;\n  top: 267px;\n  transform: rotate(-43deg);\n}\n.printout .text-wrapper-4 {\n  color: #000000;\n  font-family: Open Sans-SemiBold variable, Helvetica;\n  font-size: 5px;\n  font-weight: 600;\n  height: 11px;\n  /*left: 60px;*/\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  /*top: 167px;*/\n  left: 196px;\n  top: 140px;\n  transform: rotate(-47deg);\n}\n.printout .frame-footer {\n  align-items: flex-start;\n  flex: 0 0 auto;\n  flex-direction: column;\n  gap: 32px;\n  position: absolute;\n  bottom: 0;\n  width: 695px;\n}\n\n.backbutton {\n  align-self: flex-end;\n}\n\n.csvgen {\n  display:block;\n}\n\n.csvgen .sameType{\n  display: flex;\n  gap: 10px;\n}\n\n\n.canvasButton {\n    color: var(--brand-14bis-blue-medium);\n    border-color: var(--brand-color);\n    box-sizing: border-box;\n    font-family: Open Sans variable, Helvetica;\n    border: none;\n    background: none;\n    font-size: 14px;\n    letter-spacing: 0;\n    position: relative;\n    white-space: nowrap;\n    width: fit-content;\n}\n\n.canvasAddonButton {\n  color: var(--brand-14bis-blue-medium);\n  background-color: var(--brand-14bis-orange-brigh);\n  box-sizing: border-box;\n  font-family: Open Sans variable, Helvetica;\n  border: none;\n  font-size: 14px;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.leveltext{\n  top:10px;\n  color: var(--brand-14bis-blue-medium);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 14px;\n  letter-spacing: 0;\n  position: relative;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.twoFactor {\n  max-width: 400px;\n  text-align: center;\n  margin: 50px auto;\n  font-family: Open Sans variable, Helvetica;\n\n}\n\n.twoFactor .title {\n  font-size: 24px;\n  margin-bottom: 16px;\n  text-align: center;\n  font-family: Open Sans variable, Helvetica;\n}\n\n.twoFactor .form {\n  display: flex;\n  flex-direction: column;\n}\n\n.twoFactor .input {\n  padding: 10px;\n  margin-bottom: 16px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-family: Open Sans variable, Helvetica;\n\n}\n\n.twoFactor .verify-button {\n  padding: 10px 16px;\n  background-color: var(--brand-14bis-blue-medium);\n  font-family: Open Sans variable, Helvetica;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.twoFactor .verify-button:hover {\n  background-color: #0056b3;\n}\n\n.twoFactor .verify-button.green {\n  background-color: #28a745;\n}\n\n.twoFactor .verify-button.green:hover {\n  background-color: #218838;\n}\n\n.twoFactor .verify-button.red {\n  background-color: #dc3545;\n}\n\n.twoFactor .button.red:hover {\n  background-color: #c82333;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
